<template>
  <v-container grid-list-md class="pa-0 ma-0" fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title class="py-0 pl-1 title grey lighten-4">
            <v-flex xs10 sm8 class="pa-0">
              <span v-for="(chip, index) in reportChip" :key="index">
                <v-chip
  :style="[
    $vuetify.breakpoint.smAndUp ? {} : { width: '30%' },
    enableChip === chip ? { backgroundColor: '#4DA6A1', color: 'white' } : {}
  ]"
  small
  @click="loadDashboardBasedOnPeriod(chip)"
>
                  {{chip}}
                </v-chip>
              </span>
            </v-flex>
            <v-flex xs2 sm4 class="text-xs-right pl-0 pr-1">
              <v-chip small :disabled="true" v-if="$vuetify.breakpoint.smAndUp" class="caption grey white--text" @click="enableAutoRef()" :class="isAutoRef ? 'warning white--text' : ''">AUTO REFRESH</v-chip>
              <v-chip small :disabled="true" class="caption grey white--text mr-0" @click="EnableTrend()" :class="enableTrend === true ? 'warning white--text' : ''">TREND</v-chip>
            </v-flex>
            <v-flex xs12 sm6 v-if="enableChip === 'Period'">
              <v-layout row wrap class="ml-2">
                <v-flex xs5>
                  <v-dialog ref="dlgPeriodFrom"
                  persistent v-model="dlgPeriodFrom"
                  lazy max-width="290px"
                  :return-value.sync="periodFrom"
                  >
                  <v-text-field
                  slot="activator" label="From"
                  v-model="periodFrom" append-icon="event"
                  readonly clearable hide-details
                  ></v-text-field>
                  <v-date-picker v-model="periodFrom" scrollable
                  first-day-of-week="1"
                  >
                  <v-spacer></v-spacer>
                  <v-btn flat @click="dlgPeriodFrom = false">Cancel</v-btn>
                  <v-btn flat color="accent" @click="$refs.dlgPeriodFrom.save(periodFrom)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs5>
              <v-dialog ref="dlgPeriodTo"
              persistent v-model="dlgPeriodTo"
              lazy max-width="290px"
              :return-value.sync="periodTo"
              >
              <v-text-field
              slot="activator" label="To"
              v-model="periodTo" append-icon="event"
              readonly clearable hide-details
              ></v-text-field>
              <v-date-picker v-model="periodTo" scrollable
              first-day-of-week="1"
              >
              <v-spacer></v-spacer>
              <v-btn flat @click="dlgPeriodTo = false">Cancel</v-btn>
              <v-btn flat color="accent" @click="$refs.dlgPeriodTo.save(periodTo)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs2 class="text-xs-center">
          <v-btn small fab class="accent" @click.native="loadDashboardBasedOnPeriod('Period')">Go</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-card-title>
  <v-card-text class="pa-2">
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-right">
        <v-btn small class="ma-0" @click="showUploadImage = true"><v-icon class="pr-2">insert_photo</v-icon>{{ 'Photos (' + lDailyUpdateAttach.fileUrls.length + ')'}}</v-btn>
        <router-link :to="{ path: '/DailyReport/' + handy.formatDBDate(fromDate + ' 00:00:00') }" style="text-decoration: none; color: black;">
          <v-btn small class="ma-0 accent" :disabled="!aDay">GENERATE REPORT</v-btn>
        </router-link>
        <router-link :to="{ path: '/WeeklyReport/' + handy.formatDBDate(fromDate + ' 00:00:00') }" style="text-decoration: none; color: black;">
          <v-btn small class="ma-0 accent" :disabled="!aWeek">WEEK REPORT</v-btn>
        </router-link>
      </v-flex>
      <!-- Attendance Summary -->
      <v-flex xs12 ref="bp_attendance">
        <v-card>
          <v-card-title class="pl-2 py-0 pr-0 grey lighten-4">
            <div class="title grey--text">Attendance<br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{chosenPeriod}}</span></div>
            <v-spacer></v-spacer>
            <v-btn icon @click="showAttendanceSummary()"><v-icon>open_in_new</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pt-1 pb-0">
            <v-layout>
              <v-flex xs12 sm6 mx-auto>
                <div>
                  <v-layout row wrap class="text-xs-center">
                    <v-flex xs12>
                      <div><v-btn large fab color="blue white--text title" @click="showAttendanceSummary()">{{ lAtt.attAve + '%' }}</v-btn></div>
                    </v-flex>
                    <v-flex class="pa-0">
                      <div>
                        <v-chip color="rgba(227,108,9,0.8)" disabled class="white--text subheading px-1 mx-0">{{ (lAtt.tot_present ? lAtt.tot_present : 0) + '/' + lAtt.tot_staff }}</v-chip>
                      </div>
                      <div>Present</div>
                    </v-flex>
                    <v-flex class="pa-0">
                      <div>
                        <v-chip color="rgba(149,55,52,0.8)" disabled class="white--text subheading px-1 mx-0">{{ lAtt.tot_wo ? lAtt.tot_wo : 0 }}</v-chip>
                      </div>
                      <div>WO</div>
                    </v-flex>
                    <v-flex class="pa-0">
                      <div>
                        <v-chip color="rgba(118,146,60,0.8)" disabled class="white--text subheading px-1 mx-0">{{ lAtt.tot_ot ? lAtt.tot_ot : 0 }}</v-chip>
                      </div>
                      <div>Sby/OT</div>
                    </v-flex>
                    <v-flex class="pa-0">
                      <div>
                        <v-chip color="rgba(95,73,122,0.8)" disabled class="white--text subheading px-1 mx-0">{{ (lAtt.tot_absent || lAtt.tot_leave) ? (lAtt.tot_absent + lAtt.tot_leave) : 0 }}</v-chip>
                      </div>
                      <div>Leave/Ab</div>
                    </v-flex>
                    <v-flex class="pa-0">
                      <div>
                        <v-chip color="rgba(54,96,146,0.8)" disabled class="white--text subheading px-1">{{ lAtt.tot_pend || 0 }}</v-chip>
                      </div>
                      <div>Pending</div>
                    </v-flex>
                    <v-flex xs12 v-if="enableTrend === true">
                      <v-layout row wrap>
                        <v-flex xs5>
                          <v-divider class="mt-2 primary"></v-divider>
                        </v-flex>
                        <v-flex xs2 class="caption primary--text">
                          TREND
                        </v-flex>
                        <v-flex xs5>
                          <v-divider class="mt-2 primary"></v-divider>
                        </v-flex>
                        <v-flex xs12>
                          <div id="div_attend">
                            <canvas id="chart_attend"></canvas>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-flex xs12>
            <v-layout>
              <v-flex xs11 class="pa-0">
                <div :class="aDay ? 'caption pl-1' : 'caption pl-1 pt-3'">
                  <span style="font-weight: bold;">Remark:</span> {{ lReport.remark_attendance ? lReport.remark_attendance : 'NA' }}
                </div>
              </v-flex>
              <v-flex xs1 class="pa-0 text-xs-center">
                <v-btn class="accent--text" flat v-if="!aDay" @click="loadMoreRemark('Att')">More</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card>
      </v-flex>

      <!-- Compliance Dashboard -->
      <v-flex xs12 ref="bp_compliance">
        <v-card>
          <v-card-title class="pl-2 py-0 pr-0 grey lighten-4">
            <div class="title grey--text">Compliance Dashboard</div>
            <v-spacer></v-spacer>
            <v-btn icon @click="showComplianceDetail()"><v-icon>open_in_new</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pt-2 pb-2">
            <v-layout row wrap>

              <!-- API 1: Overall Status - ONE BIG PROGRESS BAR -->
              <v-flex xs12 sm4>
                <v-card flat>
                  <v-card-title class="subheading pa-2 text-xs-center">
                    Overall Compliance Status
                  </v-card-title>
                  <v-card-text class="text-xs-center pa-3">
                    <div id="div_compliance_overall_chart" style="max-width: 200px; margin: 0 auto;">
                      <canvas id="chart_compliance_overall"></canvas>
                    </div>
                    <v-layout row wrap class="mt-3">
                      <v-flex xs4 class="pa-1">
                        <v-chip small color="green" text-color="white" class="ma-0" @click="showComplianceDetails('active')">
                          <v-icon small left>check_circle</v-icon>
                          {{ complianceOverall.ActiveCount }}
                        </v-chip>
                        <div class="caption mt-1">Active</div>
                      </v-flex>
                      <v-flex xs4 class="pa-1">
                        <v-chip small color="orange" text-color="white" class="ma-0" @click="showComplianceDetails('aboutToExpire')">
                          <v-icon small left>warning</v-icon>
                          {{ complianceOverall.About_to_expiredCount }}
                        </v-chip>
                        <div class="caption mt-1">Expiring</div>
                      </v-flex>
                      <v-flex xs4 class="pa-1">
                        <v-chip small color="red" text-color="white" class="ma-0" @click="showComplianceDetails('expired')">
                          <v-icon small left>cancel</v-icon>
                          {{ complianceOverall.ExpiredCount }}
                        </v-chip>
                        <div class="caption mt-1">Expired</div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>

              <!-- API 2: By Category - ONE PROGRESS BAR showing category distribution -->
              <v-flex xs12 sm4>
                <v-card flat>
                  <v-card-title class="subheading pa-2 text-xs-center">
                    Category Distribution
                  </v-card-title>
                  <v-card-text class="text-xs-center pa-3">
                    <div id="div_compliance_category_chart" style="max-width: 200px; margin: 0 auto;">
                      <canvas id="chart_compliance_category"></canvas>
                    </div>
                    <v-layout row wrap class="mt-2">
                      <v-flex xs12 v-for="(count, catName) in displayedComplianceByCategory" :key="'legend-' + catName" class="pa-1">
                      <div class="caption text-xs-left">
                        <span 
                          :style="'display:inline-block;width:12px;height:12px;background-color:' + categoryColorsForLegend[catName] + ';margin-right:5px;'">
                        </span>
                        {{ catName }}: {{ count }} ({{ calculateCategoryDistributionPercentage(count) }}%)
                      </div>
                    </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>

              <!-- API 3: Category Status - MULTIPLE SMALL PROGRESS BARS (Health) -->
              <v-flex xs12 sm4>
                <v-card flat style="overflow: visible;">
                  <v-card-title class="subheading pa-2 text-xs-center">
                    Compliance Health by Category
                  </v-card-title>
                  <v-card-text class="pa-2" style="overflow: visible;">
                    <v-layout row wrap style="overflow: visible;">
                      <v-flex
                        xs6
                        v-for="(catData, catName) in displayedComplianceCategoryStatus"
                        :key="'status-' + catName"
                        class="pa-2 text-xs-center"
                        style="overflow: visible;"
                      >
                        <div class="caption font-weight-bold mb-1">{{ catName }}</div>
                          <div
                          :id="'div_compliance_cat_' + getCategoryCanvasId(catName)"
                          style="max-width: 110px; height: 110px; margin: 0 auto; overflow: visible;"
                        >
                          <canvas :id="'chart_compliance_cat_' + getCategoryCanvasId(catName)"></canvas>
                        </div>
                        <div class="mt-1 caption">
                          <span class="green--text">{{ catData.ActiveCount }}</span> /
                          <span class="orange--text">{{ catData.About_to_expiredCount }}</span> /
                          <span class="red--text">{{ catData.ExpiredCount }}</span>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>

            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 ref="bp_water">
        <v-card>
          <v-card-title class="pa-2 grey lighten-4">
            <div class="title grey--text">Water Management<br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{chosenPeriod}}</span></div>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <!-- Water Quality -->
              <v-flex xs12>
                <v-card>
                  <v-card-title class="title pr-0 py-0">
                    <span>Water Quality{{!aDay ? ' (Average)' : ''}}</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="$vuetify.breakpoint.smAndUp ? loadTrendOverADayBasedOnPeriod('6 hrs', 'Quality') : loadTrendOverADayBasedOnPeriod('Last 1 hr', 'Quality')" :disabled="!aDay">
                      <v-icon>open_in_new</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text class="pa-0">
                    <v-layout row wrap class="text-xs-center">
                      <v-flex xs12>
                        <v-data-table
                        :headers="watQualHead"
                        :items="watList"
                        hide-actions
                        >
                        <template slot="items" slot-scope="props">
                          <tr @click="$vuetify.breakpoint.smAndUp ? loadTrendOverADayBasedOnPeriod('6 hrs', 'Quality', props.item.param_name) : loadTrendOverADayBasedOnPeriod('Last 1 hr', 'Quality', props.item.param_name)">
                            <td>{{ props.item.param_name + props.item.param_value }}</td>
                            <td :class="'pa-2 ' + (watQualVal.val && (watQualVal.val < props.item.std_val_min || watQualVal.val > props.item.std_val_max) ? 'red white--text' : (watQualVal.val ? 'green lighten-3' : ''))" v-for="(watQualVal, i) in props.item.waterQualTypeValue" :key="i">
                              {{ watQualVal.val ? watQualVal.val : '-' }}
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                    <v-flex xs12 v-if="enableTrend === true" class="pa-3">
                      <v-layout row wrap>
                        <v-flex xs5>
                          <v-divider class="mt-2 primary"></v-divider>
                        </v-flex>
                        <v-flex xs2 class="caption primary--text">
                          TREND
                        </v-flex>
                        <v-flex xs5>
                          <v-divider class="mt-2 primary"></v-divider>
                        </v-flex>
                        <v-flex xs8 sm4 mx-auto class="pb-2 pt-0">
                          <v-select
                          v-model="waterQualType"
                          :items="waterQualParamList"
                          label="Parameter"
                          hide-details
                          @input="loadWaterQualChart()"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 class="pa-2">
                          <div id="div_watqualtrend">
                            <canvas id="chart_watqualtrend"></canvas>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- Water Level -->
            <v-flex xs12 sm6>
              <v-card>
                <v-card-title class="title pb-0 pr-0 pt-2">
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs10 class="px-0 pb-0 pt-2 mt-1">
                        <span>Water Level{{!aDay ? ' (Average)' : ''}}</span>
                      </v-flex>
                      <v-flex xs2 class="pa-0 text-xs-right">
                        <v-btn icon @click="$vuetify.breakpoint.smAndUp ? loadTrendOverADayBasedOnPeriod('6 hrs', 'Level') : loadTrendOverADayBasedOnPeriod('Last 1 hr', 'Level')" :disabled="!aDay">
                          <v-icon>open_in_new</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-title>
                <v-card-text class="pt-0">
                  <v-layout row wrap class="text-xs-center">
                    <v-flex xs12>
                      <div style="padding: 1rem 1rem 1rem 0px;">
                        <div id="div_watlvl">
                          <canvas id="chart_watlvl"></canvas>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 v-if="enableTrend === true">
                      <v-layout row wrap>
                        <v-flex xs5>
                          <v-divider class="mt-2 primary"></v-divider>
                        </v-flex>
                        <v-flex xs2 class="caption primary--text">
                          TREND
                        </v-flex>
                        <v-flex xs5>
                          <v-divider class="mt-2 primary"></v-divider>
                        </v-flex>
                        <v-flex xs12 class="pa-0">
                          <div id="div_watlvltrend" style="min-height: 222px;">
                            <canvas id="chart_watlvltrend"></canvas>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- Water Consumption -->
            <v-flex xs12 sm6>
              <v-card>
                <v-card-title class="title pb-0 pr-0 pt-2">
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs10>
                        <v-layout row wrap>
                          <v-flex xs12 sm5 class="px-0 pb-0 pt-2 mt-1">
                            <span>Water {{!aDay ? 'Cons. (Total)' : 'Consumption'}}</span>
                          </v-flex>
                          <v-flex xs12 sm7 class="text-xs-right">
                            <span v-for="(chip, index) in consumptionChip" :key="index"><v-chip small @click="loadWaterConsumptionBasedonChip(chip)" :class="choosenType === chip ? 'caption' : 'caption'"
  :style="choosenType === chip ? { backgroundColor: '#4DA6A1', color: 'white' } : {}">
                              
                                {{chip}}
                              </v-chip>
                            </span></v-chip>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs2 class="pa-0 text-xs-right">
                        <v-btn icon @click="loadTrendOverADayBasedOnPeriod('6 hrs', 'Cons')" :disabled="!aDay">
                          <v-icon>open_in_new</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-title>
                <v-card-text class="pt-0 pr-0">
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs6 class="py-2 text-xs-center">
                        <v-chip color="rgba(149,55,52,0.8)" disabled class="white--text title px-1 py-1">{{ consumedVal > 0 ? (consumedVal.toFixed(0) + ' KL') : 'NA' }}</v-chip>
                      </v-flex>
                      <!-- <v-flex xs6 class="pa-0 text-xs-center">
                      <v-chip color="rgba(95,73,122,0.8)" disabled class="white--text caption px-1 py-1">{{ receivedVal > 0 ? receivedVal.toFixed(2) : 'NA' }}</v-chip>
                      <br/>
                      <span class="caption">TOT RECEIVED (KL)</span>
                    </v-flex> -->
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap class="text-xs-center">
                    <v-flex xs12 sm8 class="pa-0">
                      <div style=" padding: 1rem 1rem 1rem 10px;">
                        <div id="div_watcons">
                          <canvas id="chart_watcons"></canvas>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <v-flex xs12 v-if="!$vuetify.breakpoint.smAndUp">
                        <v-layout row wrap class="pt-2">
                          <v-flex class="mt-2">
                            <v-divider></v-divider>
                          </v-flex>
                          <v-flex xs6>
                            <div>
                              <b>Water Sources (KL)</b>
                            </div>
                          </v-flex>
                          <v-flex class="mt-2">
                            <v-divider></v-divider>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 v-else>
                        <b>SOURCES (KL)</b>
                      </v-flex>
                      <v-layout row wrap>
                        <v-flex xs12 v-for="(wat, i) in domWatList" :key="i" class="py-2 pl-2">
                          <v-layout row wrap>
                            <v-flex xs9 class="text-xs-left">
                              <div style="font-size: 12px;">{{wat.water_type}}</div>
                            </v-flex>
                            <v-flex xs3 class="text-xs-left title">
                              <div style="font-size: 12px;">{{wat.water_receipt ? wat.water_receipt.toFixed(0) : 0}}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 v-if="enableTrend === true">
                      <v-layout row wrap>
                        <v-flex xs5>
                          <v-divider class="mt-2 primary"></v-divider>
                        </v-flex>
                        <v-flex xs2 class="caption primary--text">
                          TREND
                        </v-flex>
                        <v-flex xs5>
                          <v-divider class="mt-2 primary"></v-divider>
                        </v-flex>
                        <v-flex xs8 sm6 mx-auto class="pb-3 pt-0">
                          <v-select
                          v-model="waterConsType"
                          :items="waterConsTypeList"
                          label="Storage"
                          hide-details
                          @input="loadWaterConsChart()"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12>
                          <div id="div_watconstrend">
                            <canvas id="chart_watconstrend"></canvas>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-flex xs12>
        <v-layout>
          <v-flex xs11 class="pa-0">
            <div :class="aDay ? 'caption pl-1' : 'caption pl-1 pt-3'">
              <span style="font-weight: bold;">Remark:</span> {{ lReport.remark_water ? lReport.remark_water : 'NA' }}
            </div>
          </v-flex>
          <v-flex xs1 class="pa-0 text-xs-center">
            <v-btn class="accent--text" flat v-if="!aDay" @click="loadMoreRemark('Water')">More</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card>
  </v-flex>
  <v-flex xs12 ref="bp_power">
    <v-card>
      <v-card-title class="pa-2 grey lighten-4">
        <div class="title grey--text">Power Management<br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{chosenPeriod}}</span></div>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <!-- Power Consumption -->
          <v-flex xs12 sm6>
            <v-card>
              <v-card-title class="title pa-2">
                <v-flex xs10>
                  Power Consumption{{!aDay ? ' (Total)' : ''}}
                </v-flex>
                <v-flex xs2 class="pa-0 text-xs-right">
                  <v-btn class="ma-0" icon @click="loadTrendOverADayBasedOnPeriod('', 'Power')">
                    <v-icon>pie_chart</v-icon>
                  </v-btn>
                </v-flex>
              </v-card-title>
              <v-card-text>
                <v-layout row wrap class="text-xs-center">
                  <v-flex xs12 :style="$vuetify.breakpoint.smAndUp ? 'min-height: 150px;' : ''">
                    <v-layout row wrap class="text-xs-center">
                      <v-flex xs6 @click="loadTrendOverADayBasedOnPeriod('', 'Power')" style="cursor: pointer;">
                        <div>
                          <v-chip color="rgba(95,73,122,0.8)" disabled class="white--text title px-1 py-1">
                            <span @click="loadTrendOverADayBasedOnPeriod('', 'Power')" style="cursor: pointer;">{{ powCons ? powCons + ' units' : 'NA' }}</span>
                          </v-chip>
                        </div>
                        <div>Electricity Board</div>
                      </v-flex>
                      <v-flex xs6 @click="loadTrendOverADayBasedOnPeriod('', 'Power')" style="cursor: pointer;">
                        <div>
                          <v-chip color="rgba(149,55,52,0.8)" disabled class="white--text title px-1 py-1">
                            <span @click="loadTrendOverADayBasedOnPeriod('', 'Power')" style="cursor: pointer;">{{ genCons ? genCons + ' units' : 'NA' }}</span>
                          </v-chip>
                        </div>
                        <div>Genset</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-if="enableTrend === true">
                    <v-layout row wrap>
                      <v-flex xs5>
                        <v-divider class="mt-2 primary"></v-divider>
                      </v-flex>
                      <v-flex xs2 class="caption primary--text">
                        TREND
                      </v-flex>
                      <v-flex xs5>
                        <v-divider class="mt-2 primary"></v-divider>
                      </v-flex>
                      <v-flex xs12>
                        <div id="div_powconstrend">
                          <canvas id="chart_powconstrend"></canvas>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <!-- Diesel Consumption & Level -->
          <v-flex xs12 sm6>
            <v-card>
              <v-card-title class="title pa-2">
                <v-flex xs10>
                  Diesel Consumption &amp; Level
                </v-flex>
              </v-card-title>
              <v-card-text>
                <v-layout row wrap class="text-xs-center">
                  <v-flex xs6 sm2 class="pl-0">
                    <div>
                      <v-chip color="rgba(95,73,122,0.8)" disabled class="white--text subheading pa-1">{{ diCons !== 'NaN' ? diCons + ' L' : '0 L' }}</v-chip>
                    </div>
                    <div class="pl-1">Purchased{{!aDay ? ' (Total)' : ''}}</div>
                  </v-flex>
                  <v-flex xs6 sm2 class="pl-0">
                    <div>
                      <v-chip color="rgba(149,55,52,0.8)" disabled class="white--text subheading pa-1">{{ diStock !== 'NaN' ? diStock + ' L' : '0 L' }}</v-chip>
                    </div>
                    <div class="pl-2">Stock{{!aDay ? ' (Average)' : ''}}</div>
                  </v-flex>
                  <v-flex xs12 sm8>
                    <div id="div_dicons">
                      <canvas id="chart_dicons"></canvas>
                    </div>
                  </v-flex>
                  <v-flex xs12 v-if="enableTrend === true">
                    <v-layout row wrap>
                      <v-flex xs5>
                        <v-divider class="mt-2 primary"></v-divider>
                      </v-flex>
                      <v-flex xs2 class="caption primary--text">
                        TREND
                      </v-flex>
                      <v-flex xs5>
                        <v-divider class="mt-2 primary"></v-divider>
                      </v-flex>
                      <v-flex xs12>
                        <div id="div_diconstrend">
                          <canvas id="chart_diconstrend"></canvas>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-flex xs12>
        <v-layout>
          <v-flex xs11 class="pa-0">
            <div :class="aDay ? 'caption pl-1' : 'caption pl-1 pt-3'">
              <span style="font-weight: bold;">Remark:</span> {{ lReport.remark_power ? lReport.remark_power : 'NA' }}
            </div>
          </v-flex>
          <v-flex xs1 class="pa-0 text-xs-center">
            <v-btn class="accent--text" flat v-if="!aDay" @click="loadMoreRemark('Power')">More</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card>
  </v-flex>
  <!-- Waste Management -->
  <v-flex xs12>
    <v-card>
      <v-card-title class="pa-2 grey lighten-4">
        <div class="title grey--text">Waste Management{{!aDay ? ' (Total)' : ''}}<br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{chosenPeriod}}</span></div>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap class="text-xs-center">
          <v-flex xs12>
            <div id="div_waste">
              <canvas id="chart_waste"></canvas>
            </div>
          </v-flex>
          <v-flex xs12 v-if="enableTrend === true">
            <v-layout row wrap>
              <v-flex xs5>
                <v-divider class="mt-2 primary"></v-divider>
              </v-flex>
              <v-flex xs2 class="caption primary--text">
                TREND
              </v-flex>
              <v-flex xs5>
                <v-divider class="mt-2 primary"></v-divider>
              </v-flex>
              <v-flex xs12>
                <div id="div_wastetrend">
                  <canvas id="chart_wastetrend"></canvas>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
  <!-- Hygiene Management / Sanity Checks -->
  <v-flex xs12 ref="bp_sanity">
    <v-card>
      <v-card-title class="pa-2 grey lighten-4">
        <div class="title grey--text">Hygiene Management / Sanity Checks<br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{chosenPeriod}}</span></div>
      </v-card-title>
      <v-card-text :class="!aDay ? 'pa-0' : ''">
        <v-layout row wrap class="text-xs-left">
          <v-flex v-if="!aDay" class="pa-0">
            <v-btn class="accent--text" flat @click="loadSanityChecksMore()">Click here to see the list for given period</v-btn>
          </v-flex>
          <v-flex v-else xs12 class="pa-0">
            <v-flex xs12 v-for="(cat, n) in hygCats" :key="n" :class="n > 0 ? 'pa-0 mt-1' : 'pa-0'" style="border: 1px solid black;">
              <div class="text-xs-left pa-2 white--text font"
  :style="{ backgroundColor: '#4DA6A1' }">{{cat.check_cat}}</div>
              <v-data-table
              hide-headers
              :items="hygList.filter(rec => rec.check_cat === cat.check_cat)"
              hide-actions
              disable-initial-sort
              >
              <template slot="items" slot-scope="props">
                <tr>
                  <td style="width:400px;" class="pr-0">{{ props.item.check_desc }}</td>
                  <td style="width: 50px;">
                    <v-checkbox v-model="props.item.check_value" class="pt-2" hide-details readonly></v-checkbox>
                  </td>
                  <td>{{ props.item.remark ? props.item.remark : '' }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</v-flex>
<!-- Safety & Security -->
<v-flex xs12>
  <v-card>
    <v-card-title class="pa-2 grey lighten-4">
      <div class="title grey--text">Incidents<br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{chosenPeriod}}</span></div>
    </v-card-title>
    <v-card-text :class="!aDay ? 'pa-0' : ''">
      <v-layout row wrap class="text-xs-left">
        <v-flex v-if="!aDay" class="pa-0">
          <v-btn class="accent--text" flat @click="loadIncidentMore()">Click here to see the list for given period</v-btn>
        </v-flex>
        <v-flex v-else xs12 class="pa-0">
          <v-flex xs12 v-for="(incident, n) in incidentTypes" :key="n"  style="border: 1px solid black;" :class="n > 0 ? 'pa-0 mt-1' : 'pa-0'">
            <div class="text-xs-left pa-2 white--text font"
  :style="{ backgroundColor: '#4DA6A1' }">{{incident}}</div>
            <v-flex xs12 class="pa-0">
              <v-data-table
              hide-headers
              :items="incidentList.filter(rec => rec.incident_type === incident)"
              hide-actions
              disable-initial-sort>
              <template slot="items" slot-scope="props">
                <tr>
                  <td style="width:315px;" class="font">{{ props.item.incident_class }}</td>
                  <td class="font">{{ props.item.incident_on ? (handy.formatDate(props.item.incident_on) + ' ' + handy.getTime12Hrs(props.item.incident_on) + (props.item.incident_end ? ' to ' + handy.formatDate(props.item.incident_end) + ' ' + handy.getTime12Hrs(props.item.incident_end) : '') + ' - ' + props.item.incident_desc) : '' }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-card-text>
</v-card>
</v-flex>
<!-- Custom Metrics -->
<v-flex xs12 v-if="metricCat.length > 0">
  <v-card>
    <v-card-title class="pa-2 grey lighten-4">
      <div class="title grey--text">Custom Metrics<br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{chosenPeriod}}</span></div>
    </v-card-title>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 sm6 v-for="(cat, i) in metricCat" :key="i">
          <v-card>
            <v-card-title class="title">
              <v-flex xs12 class="text-xs-center">
                {{ cat }}
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap class="text-xs-center">
                <v-flex xs12>
                  <div :id="'div_other_' + cat.split(' ').join('_')">
                    <canvas :id="'chart_other_' + cat.split(' ').join('_')"></canvas>
                  </div>
                </v-flex>
                <v-flex xs12 v-if="enableTrend === true">
                  <v-layout row wrap>
                    <v-flex xs5>
                      <v-divider class="mt-2 primary"></v-divider>
                    </v-flex>
                    <v-flex xs2 class="caption primary--text">
                      TREND
                    </v-flex>
                    <v-flex xs5>
                      <v-divider class="mt-2 primary"></v-divider>
                    </v-flex>
                    <v-flex xs12>
                      <div :id="'div_other_trend_' + cat.split(' ').join('_')">
                        <canvas :id="'chart_other_trend_' + cat.split(' ').join('_')"></canvas>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</v-flex>
</v-layout>
</v-card-text>
</v-card>
</v-flex>
</v-layout>

<!-- Show Uploaded Images -->
<v-dialog v-model="showUploadImage" scrollable max-width="900px">
  <v-card>
    <v-card-title class="py-1 title grey lighten-4">
      <div>Photos <span class="caption">{{chosenPeriod }}</span></div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showUploadImage = false"><v-icon>close</v-icon></v-btn>
      <v-flex xs12 class="pb-2">
        <span v-for="(chip, index) in photoCatChips" :key="index">
          <v-chip :style="$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'" :color="lDailyUpdateAttach.cat === chip.attach_cat_id ? 'primary white--text' : ''" @click="loadCategoryImage(chip.attach_cat_id)">  {{chip.attach_cat_name + (lDailyUpdateAttach.fileUrls ? (lDailyUpdateAttach.fileUrls && lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === chip.attach_cat_id).length ? (' (' + lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === chip.attach_cat_id).length + ')') : '') : '') }}</v-chip>
        </span>
        <v-chip :color="lDailyUpdateAttach.cat === 'All' ? 'primary white--text' : ''" @click="loadCategoryImage('All')">All ({{lDailyUpdateAttach.fileUrls && lDailyUpdateAttach.fileUrls.length}})</v-chip>
      </v-flex>
    </v-card-title>
    <v-card-text>
      <v-card flat>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap v-if="lDailyUpdateAttach.files && lDailyUpdateAttach.files.length > 0">
            <v-flex xs12 sm4 v-for="(file, index) in lDailyUpdateAttach.files" :key="index" class="pa-1 text-xs-center">
              <v-card-media
              class="black--text caption"
              height="210px"
              :src="file.file_url"
              >
              <div class="white--text" style="background-color:rgba(125, 125, 125, 0.5);">{{handy.formatDBDateTime(file.attach_timestamp)}}<br />by {{file.user_name}}</div>
              <div style="position:absolute; bottom:0px; width:100%; background-color:rgba(0, 0, 255, 0.5);" class="text-xs-center white--text" v-if="file.notes">
                {{ file.notes }}
              </div>
            </v-card-media>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
          <span>
            <div class="pa-2">No photos are available.</div>
          </span>
        </v-layout>
      </v-container>
    </v-card>
  </v-card-text>
</v-card>
</v-dialog>

<!-- Compliance Details Dialog -->
<v-dialog v-model="complianceDialog" persistent scrollable max-width="900px">
  <v-card>
    <v-card-title class="pa-2 grey lighten-4">
      <div class="title grey--text">{{ complianceDialogTitle }}</div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="complianceDialog = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
        :headers="complianceHeaders"
        :items="complianceDetails"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ props.item.compliance_name }}</td>
            <td>{{ props.item.category_name }}</td>
            <td>{{ props.item.subcategory_name || '-' }}</td>
            <td>{{ props.item.compliance_type || '-' }}</td>
            <td>{{ handy.formatDate(props.item.valid_from) }}</td>
            <td>{{ handy.formatDate(props.item.valid_to) }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</v-dialog>

<!-- Category Details Dialog -->
<v-dialog v-model="categoryDialog" persistent scrollable max-width="1000px">
  <v-card>
    <v-card-title class="pa-2 grey lighten-4">
      <div class="title grey--text">{{ categoryDialogTitle }}</div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="categoryDialog = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
        :headers="categoryHeaders"
        :items="categoryDetails"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ props.item.compliance_name }}</td>
            <td>{{ props.item.category_name }}</td>
            <td>{{ props.item.subcategory_name || '-' }}</td>
            <td>{{ props.item.compliance_type_name || '-' }}</td>
            <td>{{ handy.formatDate(props.item.valid_from) }}</td>
            <td>{{ handy.formatDate(props.item.valid_to) }}</td>
            <td>
              <v-chip
                small
                :color="props.item.validity_status === 'Active' ? 'green' : (props.item.validity_status === 'About to expire' ? 'orange' : 'red')"
                text-color="white"
                class="ma-0"
              >
                {{ props.item.validity_status }}
              </v-chip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</v-dialog>

<!-- All Compliance Summary -->
<v-dialog v-model="showAllCompliance" persistent scrollable max-width="1000px">
  <v-card>
    <v-card-title class="pa-2 grey lighten-4">
      <div class="title grey--text">Compliance Summary</div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showAllCompliance = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-2">
      <v-card class="mb-3">
        <v-card-title class="pa-2 green white--text">
          <v-icon color="white" class="mr-2">check_circle</v-icon>
          <span>Active Compliances ({{ complianceDataActive.length }})</span>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-data-table
            :headers="complianceAllHeaders"
            :items="complianceDataActive"
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.compliance_name }}</td>
                <td>{{ props.item.category_name }}</td>
                <td>{{ props.item.subcategory_name || '-' }}</td>
                <td>{{ props.item.compliance_type || '-' }}</td>
                <td>{{ handy.formatDate(props.item.valid_from) }}</td>
                <td>{{ handy.formatDate(props.item.valid_to) }}</td>
                <td>{{ props.item.cost ? '₹' + props.item.cost.toLocaleString() : '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-card class="mb-3">
        <v-card-title class="pa-2 orange white--text">
          <v-icon color="white" class="mr-2">warning</v-icon>
          <span>Expiring Soon ({{ complianceDataAboutToExpire.length }})</span>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-data-table
            :headers="complianceAllHeaders"
            :items="complianceDataAboutToExpire"
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.compliance_name }}</td>
                <td>{{ props.item.category_name }}</td>
                <td>{{ props.item.subcategory_name || '-' }}</td>
                <td>{{ props.item.compliance_type || '-' }}</td>
                <td>{{ handy.formatDate(props.item.valid_from) }}</td>
                <td>{{ handy.formatDate(props.item.valid_to) }}</td>
                <td>{{ props.item.cost ? '₹' + props.item.cost.toLocaleString() : '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-card class="mb-2">
        <v-card-title class="pa-2 red white--text">
          <v-icon color="white" class="mr-2">cancel</v-icon>
          <span>Expired Compliances ({{ complianceDataExpired.length }})</span>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-data-table
            :headers="complianceAllHeaders"
            :items="complianceDataExpired"
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.compliance_name }}</td>
                <td>{{ props.item.category_name }}</td>
                <td>{{ props.item.subcategory_name || '-' }}</td>
                <td>{{ props.item.compliance_type || '-' }}</td>
                <td>{{ handy.formatDate(props.item.valid_from) }}</td>
                <td>{{ handy.formatDate(props.item.valid_to) }}</td>
                <td>{{ props.item.cost ? '₹' + props.item.cost.toLocaleString() : '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</v-dialog>

<!-- Attendance summary -->
<v-dialog v-model="showSummary" persistent scrollable max-width="850px">
  <v-card>
    <v-card-title class="pa-2 grey lighten-4">
      <div class="title grey--text">Attendance Summary</div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showSummary = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="$vuetify.breakpoint.smAndUp ? repHeadSm : repHead"
      :items="attReport"
      hide-actions>
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.staff_role }}</td>
          <td class="pa-0">{{ props.item.tot_present }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_wo }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_holiday }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_ot }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_leave }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_absent }}</td>
          <td class="red--text pa-0">{{ props.item.tot_pend }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<!-- Water Quality summary -->
<v-dialog v-model="qualityTrendOverADay" scrollable persistent max-width="960px">
  <v-flex xs12>
    <v-card>
      <v-card-title class="py-0 pr-0 grey lighten-4">
        <div class="title grey--text">
          Trend over a day
          <br v-if="!$vuetify.breakpoint.smAndUp" />
          <span class="subheading">{{chosenPeriod}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="qualityTrendOverADay = false"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-2">
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-select
            :class="$vuetify.breakpoint.smAndUp ? '' : 'pt-0 pb-2'"
            v-model="waterQualiltyType"
            :items="waterQualParamList"
            hide-details
            solo
            @change="showWaterQualityOverADay()"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 :class="$vuetify.breakpoint.smAndUp ? 'text-xs-right' : 'text-xs-center'">
            <span v-for="(chip, index) in trendChip" :key="index">
              <v-chip small @click="loadTrendOverADayBasedOnPeriod(chip, 'Quality')" :class="enableTrendChip === chip ? 'primary white--text' : ''">
                {{chip}}
              </v-chip>
            </span>
          </v-flex>
          <v-flex xs12 class="pt-3">
            <div id="div_watqualoveradaytrend">
              <canvas id="chart_watqualoveradaytrend"></canvas>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</v-dialog>

<!-- Water Level summary -->
<v-dialog v-model="lvlTrendOverADay" scrollable persistent max-width="960px">
  <v-flex xs12>
    <v-card>
      <v-card-title class="py-0 pr-0 grey lighten-4">
        <div class="title grey--text">
          Trend over a day
          <br v-if="!$vuetify.breakpoint.smAndUp" />
          <span class="subheading">{{chosenPeriod}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="lvlTrendOverADay = false"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-2">
        <v-layout row wrap>
          <v-flex xs12 sm8>
            <v-select
            :class="$vuetify.breakpoint.smAndUp ? 'pt-0' : 'pt-0 pb-2'"
            v-model="selectedStorageNmWithWaterLvl"
            :items="storageNmListWithWaterLvl"
            item-value="storage_id"
            item-text="storage_nm"
            hide-details
            clearable
            @change="showWaterLevelOverADay()"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm4 :class="$vuetify.breakpoint.smAndUp ? 'text-xs-right' : 'text-xs-center'">
            <span v-for="(chip, index) in trendChip" :key="index">
              <v-chip small @click="loadTrendOverADayBasedOnPeriod(chip, 'Level')" :class="enableTrendChip === chip ? 'primary white--text' : ''">
                {{chip}}
              </v-chip>
            </span>
          </v-flex>
          <v-flex xs12 class="text-xs-right" v-if="watTankBattery">
            <span>
              <v-icon class="mt-2" v-if="watTankBattery > 20" style="transform: rotate(-90deg);" color="#00d455">battery_full</v-icon>
              <v-icon v-else style="transform: rotate(-90deg);" color="error">battery_alert</v-icon>
            </span>
            <span class="caption">{{watTankBattery + '%'}}</span>
          </v-flex>
          <v-flex xs12 class="pt-2">
            <div id="div_watlvloveradaytrend">
              <canvas id="chart_watlvloveradaytrend"></canvas>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</v-dialog>

<!-- Water Cons summary -->
<v-dialog v-model="consTrendOverADay" scrollable persistent max-width="960px">
  <v-flex xs12>
    <v-card>
      <v-card-title class="py-0 pr-0 grey lighten-4">
        <div class="title grey--text">
          Trend over a day
          <br v-if="!$vuetify.breakpoint.smAndUp" />
          <span class="subheading">{{chosenPeriod}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="consTrendOverADay = false"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-2">
        <v-layout row wrap>
          <v-flex xs12 sm8>
            <v-select
            :class="$vuetify.breakpoint.smAndUp ? 'pt-0' : 'pt-0 pb-2'"
            v-model="selectedStorageNmWithWaterCons"
            :items="storageNmListWithWaterCons"
            item-value="storage_id"
            item-text="storage_nm"
            hide-details
            clearable
            @change="showWaterConsOverADay()"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm4 :class="$vuetify.breakpoint.smAndUp ? 'text-xs-right' : 'text-xs-center'">
            <span v-for="(chip, index) in waterConsTrendChip" :key="index">
              <v-chip small @click="loadTrendOverADayBasedOnPeriod(chip, 'Cons')" :class="enableTrendChip === chip ? 'primary white--text' : ''">
                {{chip}}
              </v-chip>
            </span>
          </v-flex>
          <v-flex xs12 class="pt-2">
            <div id="div_watConsoveradaytrend">
              <canvas id="chart_watConsoveradaytrend"></canvas>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</v-dialog>

<!-- Power Cons summary -->
<v-dialog v-model="showPowerConstrendOverADay" scrollable persistent max-width="960px">
  <v-flex xs12>
    <v-card>
      <v-card-title class="py-0 pr-0 grey lighten-4">
        <div class="title grey--text">
          Power cons. breakup
          <br v-if="!$vuetify.breakpoint.smAndUp" />
          <span class="subheading">{{chosenPeriod}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="showPowerConstrendOverADay = false"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-2">
        <v-layout row wrap>
          <v-flex xs12 sm6 class="text-xs-center">
            <div id="div_powconstrendoveraday">
              <canvas id="chart_powconstrendoveraday"></canvas>
            </div>
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-center">
            <div id="div_powgensettrendoveraday">
              <canvas id="chart_powgensettrendoveraday"></canvas>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</v-dialog>

<!-- Sanity checks -->
<v-dialog v-model="showSanityChecks" scroll max-width="750">
  <v-flex xs12>
    <v-card>
      <v-card-title class="py-0 pr-0 grey lighten-4">
        <div class="title grey--text">
          Hygiene Management / Sanity Checks
          <br v-if="!$vuetify.breakpoint.smAndUp" />
          <span class="subheading">{{chosenPeriod}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="showSanityChecks = false"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-flex xs12 v-for="(item, n) in lSan" :key="n" :class="n > 0 ? 'mt-2' : ''">
          <div class="pa-2 primary white--text">{{item}}</div>
          <v-data-table
          :headers="sanHeads"
          :items="sanList.filter(rec => handy.formatDate(rec.c_date) === item)"
          hide-actions
          disable-initial-sort
          class="elevation-1"
          >
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{ props.item.check_cat }}</td>
              <td>{{ props.item.check_desc }}</td>
              <td style="width: 340px;">{{ props.item.remark ? props.item.remark : '-' }}</td>
              <td class="text-xs-right" style="width: 50px;">
                <v-checkbox v-model="props.item.check_value" class="pt-2" hide-details readonly></v-checkbox>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</v-flex>
</v-dialog>

<!-- Incident -->
<v-dialog v-model="showIncident" scroll max-width="750">
  <v-flex xs12>
    <v-card>
      <v-card-title class="py-0 pr-0 grey lighten-4">
        <div class="title grey--text">
          Incidents
          <br v-if="!$vuetify.breakpoint.smAndUp" />
          <span class="subheading">{{chosenPeriod}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="showIncident = false"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-flex xs12 v-for="(item, n) in lInc" :key="n" :class="n > 0 ? 'mt-2' : ''">
          <div class="pa-2 primary white--text">{{item}}</div>
          <v-data-table
          :headers="incHeads"
          :items="lIncident.filter(rec => handy.formatDate(rec.created_on) === item)"
          hide-actions
          disable-initial-sort
          class="elevation-1"
          >
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{ props.item.incident_type }}</td>
              <td>{{ props.item.incident_class }}</td>
              <td>{{ props.item.incident_desc }}</td>
              <td>{{ props.item.incident_on ? (handy.formatDate(props.item.incident_on) + ' ' + handy.getTime12Hrs(props.item.incident_on) + (props.item.incident_end ? ' to ' + handy.formatDate(props.item.incident_end) + ' ' + handy.getTime12Hrs(props.item.incident_end) : '')) : '' }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</v-flex>
</v-dialog>

<!-- More Attendance Remark -->
<v-dialog v-model="showRemark" scroll max-width="750">
  <v-flex xs12>
    <v-card>
      <v-card-title class="py-0 pr-0 grey lighten-4">
        <div class="title grey--text">
          <span>{{ lReport.remark === 'Att' ? 'Attendance Remarks' : lReport.remark === 'Power' ? 'Power Remarks' : lReport.remark === 'Water' ? 'Water Remarks' : '' }}</span>
          <br v-if="!$vuetify.breakpoint.smAndUp" />
          <span class="subheading">{{chosenPeriod}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="showRemark = false"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-flex xs12>
          <v-data-table
          :headers="AttHeads"
          :items="lReport.remark === 'Att' ? lReport.AttRemark : lReport.remark === 'Power' ? lReport.PowerRemark : lReport.remark === 'Water' ? lReport.WaterRemark : ''"
          hide-actions
          disable-initial-sort
          class="elevation-1"
          >
          <template slot="items" slot-scope="props">
            <tr>
              <td style="width: 150px;">{{ handy.formatDate(props.item.c_date) }}</td>
              <td v-if="lReport.remark === 'Att'">{{ props.item.remark_attendance ? props.item.remark_attendance : '-' }}</td>
              <td v-if="lReport.remark === 'Power'">{{ props.item.remark_power ? props.item.remark_power : '-' }}</td>
              <td v-if="lReport.remark === 'Water'">{{ props.item.remark_water ? props.item.remark_water : '-' }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</v-flex>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar" :timeout="2000" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<style>
.ccolor1 {
  background-color:rgba(227,108,9,0.8);
}
.ccolor2 {
  background-color:rgba(49,133,155,0.8);
}
.ccolor3 {
  background-color:rgba(95,73,122,0.8);
}
.ccolor4 {
  background-color:rgba(118,146,60,0.8);
}
.ccolor5 {
  background-color:rgba(149,55,52,0.8);
}
.ccolor6 {
  background-color:rgba(54,96,146,0.8);
}
.ccolor7 {
  background-color:rgba(23,54,93,0.8);
}
.ccolor8 {
  background-color:rgba(73,68,41,0.8);
}
</style>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import axios from 'axios'
import { createApiRequestScheduler } from '@/utils/apiRequestScheduler'
var Chart = require('chart.js')
import 'chartjs-plugin-datalabels'

var COLORS = ['227,108,9', '49,133,155', '95,73,122', '118,146,60', '149,55,52', '54,96,146', '23,54,93', '73,68,41']

// Module-level (not component-level) so the cache and cancellation state survive navigating
// away from and back to this component. The scheduler itself (caching, batched execution --
// up to dashboardApiBatchSize requests run concurrently per batch, batches run one after
// another -- TTL, force-refresh, cancellation) is generic/reusable -- see src/utils/apiRequestScheduler.js
// -- everything Facdash-specific (which APIs, batch size, TTL values, live/historical
// detection) stays below in the component.
var dashboardScheduler = createApiRequestScheduler({
  isCancel: axios.isCancel,
  cancelTokenSource: function () { return axios.CancelToken.source() }
})

export default {
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      reportChip: ['Last Month', 'Last Week', 'Yesterday', 'Today', 'This Week', 'This Month', 'Period'],
      fromDate: null,
      toDate: null,
      trendFrom: null,
      trendTo: null,
      fromDt: null,
      toDt: null,
      enableChip: '',
      handy: handy,
      config: config,
      lAtt: {
        tot_present: 0,
        tot_wo: 0,
        tot_holiday: 0,
        tot_ot: 0,
        tot_leave: 0,
        tot_absent: 0,
        tot_pend: 0,
        tot_staff: 0,
        attAve: 0
      },
      dlgPeriodFrom: false,
      dlgPeriodTo: false,
      periodFrom: '',
      periodTo: '',
      aDay: false,
      tmpChart: [],
      tmpChart2: [],
      enableTrend: false,
      waterConsType: '',
      // Compliance
      complianceOverall: {
        ActiveCount: 0,
        About_to_expiredCount: 0,
        ExpiredCount: 0,
        activePercentage: 0
      },
      complianceByCategory: {},
      complianceCategoryStatus: {},
      complianceCategoryChart: null,
      categoryColorsForLegend: {},
      // Compliance dialog
      complianceDialog: false,
      showAllCompliance: false,
      complianceDialogTitle: '',
      complianceDetails: [],
      // Compliance detailed data
      complianceDataActive: [],
      complianceDataAboutToExpire: [],
      complianceDataExpired: [],
      complianceHeaders: [
        { text: 'Compliance', value: 'compliance_name' },
        { text: 'Category', value: 'category_name' },
        { text: 'Subcategory', value: 'subcategory_name' },
        { text: 'Type', value: 'compliance_type' },
        { text: 'Valid From', value: 'valid_from' },
        { text: 'Valid To', value: 'valid_to' }
      ],
      complianceAllHeaders: [
        { text: 'Compliance', value: 'compliance_name' },
        { text: 'Category', value: 'category_name' },
        { text: 'Subcategory', value: 'subcategory_name' },
        { text: 'Type', value: 'compliance_type' },
        { text: 'Valid From', value: 'valid_from' },
        { text: 'Valid To', value: 'valid_to' },
        { text: 'Cost (₹)', value: 'cost' }
      ],
      // Category dialog
      complianceByCategoryData: {},
      categoryDialog: false,
      categoryDialogTitle: '',
      categoryDetails: [],
      categoryHeaders: [
        { text: 'Compliance', value: 'compliance_name' },
        { text: 'Category', value: 'category_name' },
        { text: 'Subcategory', value: 'subcategory_name' },
        { text: 'Type', value: 'compliance_type_name' },
        { text: 'Valid From', value: 'valid_from' },
        { text: 'Valid To', value: 'valid_to' },
        { text: 'Status', value: 'validity_status' }
      ],
      // water sources
      domWatList: [],
      waterConsTypeList: [],
      waterQualParamList: [],
      waterQualType: '',
      waterQualiltyType: '',
      watQualHead: [], // constructed dynamically
      watList: [],
      consumptionChip: ['Domestic', 'Recycled/Treated'],
      choosenType: 'Domestic',
      tankerVal: 0,
      receivedVal: 0,
      consumedVal: 0,
      powCons: '',
      genCons: '',
      diCons: '',
      diStock: '',
      metricCat: [],
      lDailyUpdateAttach: {
        fileUrls: [],
        files: []
      },
      showUploadImage: false,
      photoCatChips: [],
      showSummary: false,
      repHeadSm: [
        { text: 'Role [Headcount]', value: 'staff_role' },
        { text: 'Present', value: 'tot_present', class: 'pa-0' },
        { text: 'Weekoff', value: 'tot_wo' },
        { text: 'Holiday', value: 'tot_holiday' },
        { text: 'Standby/OT', value: 'tot_ot' },
        { text: 'Leave', value: 'tot_leave' },
        { text: 'Absent', value: 'tot_absent' },
        { text: 'Pending', value: 'tot_pend', class: 'red--text pa-0' }
      ],
      repHead: [
        { text: 'Role', value: 'staff_role' },
        { text: 'Present', value: 'tot_present', class: 'pa-0' },
        { text: 'Pending', value: 'tot_pend', class: 'red--text pa-0' }
      ],
      attReport: [],
      // common chip for all summary trend
      trendChip: ['Last 1 hr', '6 hrs', '12 hrs', 'A day'],
      waterConsTrendChip: ['6 hrs', '12 hrs', 'A day'],
      enableTrendChip: '',
      // water quality summary
      qualityTrendOverADay: false,
      waterTypeLebel: [],
      fromTime: null,
      toTime: null,
      // water lvl summary
      storageNmListWithWaterLvl: [],
      selectedStorageNmWithWaterLvl: [],
      lvlTrendOverADay: false,
      watTankBattery: null,
      // water cons summary
      storageNmListWithWaterCons: [],
      selectedStorageNmWithWaterCons: [],
      consTrendOverADay: false,
      // power cons trend
      showPowerConstrendOverADay: false,
      // Hygiene
      hygList: [],
      hygCats: {},
      sanHeads: [
        { text: 'Category', value: 'check_cat' },
        { text: 'Description', value: 'check_desc' },
        { text: 'Remark', value: 'remark' },
        { text: '', value: 'check_value' }
      ],
      sanList: [],
      showSanityChecks: false,
      lSan: {},
      lWaste: {},
      // incident
      incidentList: [],
      incidentTypes: {},
      lIncident: [],
      lInc: {},
      incHeads: [
        { text: 'Type', value: 'incident_type' },
        { text: 'Class', value: 'incident_class' },
        { text: 'Description', value: 'incident_desc' },
        { text: 'Incident Date', value: 'incident_on' }
      ],
      showIncident: false,
      // remark
      lReport: {},
      showRemark: false,
      AttHeads: [
        { text: 'Date', value: 'c_date', width: '150px' },
        { text: 'Remark', value: 'remark_attendance' }
      ],
      // common
      nodata: false,
      timer: '',
      secTimer: '',
      sectionList: ['bp_attendance', 'bp_compliance', 'bp_water', 'bp_power', 'bp_sanity'],
      curSec: 0,
      isAutoRef: false,
      // Dashboard API scheduler: up to this many APIs run concurrently within a batch (via
      // Promise.all); the next batch only starts once the whole current batch has settled
      // (see runDashboardApiQueue / apiRequestScheduler.js's runQueue).
      dashboardApiBatchSize: 3,
      // how long a "live" (includes today) filter's cached response stays valid before a
      // re-visit fetches fresh data automatically
      dashboardLiveCacheTtlMs: 5 * 60 * 1000,
      // how long a historical (ends before today) filter's cached response stays valid.
      // null = cache indefinitely (data can't change), which is intentional -- set a number
      // here (ms) instead if historical data should ever expire too; no cache-logic change
      // needed either way, this is the only place that decision is made
      dashboardHistoricalCacheTtlMs: null,
      // rapid filter clicks within this window collapse to a single load of the last one picked
      dashboardFilterThrottleMs: 500,
      // whether the currently selected range includes today -- true selects the TTL above,
      // false selects the historical one (see applyDashboardPeriod)
      isLiveRange: false,
      dashboardApis: [
        'loadCustomMetricCat',
        'loadWaterConsType',
        'loadAttChart',
        'loadComplianceOverall',
        'loadComplianceByCategory',
        'loadComplianceCategoryStatus',
        'loadWaterLevelChart',
        'loadWaterConsChart',
        'loadWaterSources',
        'loadWaterQualChart',
        'loadPowerConsChart',
        'loadDieselConsChart',
        'loadWasteChart',
        'loadOtherCustomMetricChart',
        'loadPhotoCat',
        'loadFacDailyUpdateAttachment',
        'loadRemark',
        'loadHygieneCat',
        'loadIncidentClass'
      ],
      failedApis: []
    }
  },
  created () {
    // internal (non-reactive) bookkeeping for the debounce/TTL logic that's specific to this
    // dashboard -- run-token, cancellation, and the force-refresh flag are owned by
    // dashboardScheduler now, not the component
    this._dashboardHasLoadedOnce = false
    this._dashboardFilterTimer = null
    this._pendingChip = null
    this._pendingForceRefresh = false
    this._currentCacheTtlMs = null
  },
  mounted () {
    var curDate = new Date()
    this.periodFrom = this.periodTo = handy.formatDBDate(curDate)
    this.loadDashboardBasedOnPeriod('Yesterday')
  },
  beforeDestroy () {
    clearInterval(this.timer)
    clearInterval(this.secTimer)
    if (this._dashboardFilterTimer) {
      clearTimeout(this._dashboardFilterTimer)
      this._dashboardFilterTimer = null
    }
    // stop whatever's in flight/queued; a later remount starts a fresh run of its own
    dashboardScheduler.invalidateCurrentRun('Facdash component destroyed')
  },
  computed: {
    chosenPeriod: function () {
      return ' [' + ((this.enableChip === 'Today' || this.enableChip === 'Yesterday') ? handy.formatDate(this.fromDate + ' 00:00:00') : handy.formatDate(this.fromDate + ' 00:00:00') + ' to ' + handy.formatDate(this.toDate + ' 00:00:00')) + ']'
    },
    displayedComplianceCategoryStatus: function () {
      const categories = Object.entries(this.complianceCategoryStatus)
      const maxIndividual = 3 // Show 3 individual categories + 1 "Others" = 4 total

      // If 3 or fewer categories, return all
      if (categories.length <= maxIndividual) {
        return this.complianceCategoryStatus
      }

      // Take first 3 categories
      const displayed = {}
      const firstThree = categories.slice(0, maxIndividual)
      firstThree.forEach(([name, data]) => {
        displayed[name] = data
      })

      // Group remaining categories into "Others"
      const remaining = categories.slice(maxIndividual)
      const othersData = {
        ActiveCount: 0,
        About_to_expiredCount: 0,
        ExpiredCount: 0
      }

      remaining.forEach(([name, data]) => {
        othersData.ActiveCount += data.ActiveCount || 0
        othersData.About_to_expiredCount += data.About_to_expiredCount || 0
        othersData.ExpiredCount += data.ExpiredCount || 0
      })

      // Add "Others" category as the 4th category
      if (remaining.length > 0) {
        displayed['Others'] = othersData
      }

      return displayed
    },
    displayedComplianceByCategory: function () {
      const categories = Object.entries(this.complianceByCategory)
      const maxIndividual = 3 // Show 3 individual categories + 1 "Others" = 4 total

      // If 3 or fewer categories, return all
      if (categories.length <= maxIndividual) {
        return this.complianceByCategory
      }

      // Take first 3 categories
      const displayed = {}
      const firstThree = categories.slice(0, maxIndividual)
      firstThree.forEach(([name, count]) => {
        displayed[name] = count
      })

      // Group remaining categories into "Others"
      const remaining = categories.slice(maxIndividual)
      let othersCount = 0

      remaining.forEach(([name, count]) => {
        othersCount += count
      })

      // Add "Others" category as the 4th category
      if (remaining.length > 0) {
        displayed['Others'] = othersCount
      }

      return displayed
    }
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadDailyDashboardSummary () {
      this.runDashboardApiQueue(this.dashboardApis)
    },
    // Thin Facdash-specific wrapper around the reusable dashboardScheduler: builds the cache
    // key from this API's own params, supplies this dashboard's current TTL policy (set by
    // applyDashboardPeriod), and issues the request via this.axios. All caching, TTL,
    // force-refresh, staleness and cancellation logic lives in dashboardScheduler so it isn't
    // duplicated per API and can be reused by other screens.
    fetchDashboardApi (apiName, url, qry, onSuccess, onError) {
      var self = this
      return dashboardScheduler.fetchWithCache({
        key: dashboardScheduler.buildCacheKey(apiName, qry && qry.params),
        ttlMs: this._currentCacheTtlMs,
        request: function (cancelToken) {
          return self.axios.get(url, Object.assign({}, qry, { cancelToken: cancelToken }))
        },
        onSuccess: onSuccess,
        onError: onError
      })
    },
    // Runs the given list of dashboard API method names in batches of dashboardApiBatchSize
    // (concurrently within a batch, batches run one after another) via dashboardScheduler.runQueue.
    // `apiNames` is only ever a list of method names on `this` -- adding/removing/renaming an
    // API's implementation never requires touching the scheduler.
    async runDashboardApiQueue (apiNames) {
      var self = this
      var tasks = apiNames.map(function (name) {
        return { name: name, run: function () { return self[name]() } }
      })
      await dashboardScheduler.runQueue(tasks, {
        batchSize: this.dashboardApiBatchSize,
        onFailedApisChange: function (names) {
          self.failedApis = names
        }
      })
    },
    // Public entry point (bound from the filter chips / Period "Go" button / auto-refresh timer).
    // Debounces rapid filter changes: only the last selection within dashboardFilterThrottleMs
    // is actually applied. A new selection immediately invalidates whatever run is currently
    // in flight (bumping the run token and cancelling the current request) so a stale response
    // from the previous filter can never land on top of the new one, even before the throttle
    // window elapses. Re-selecting the already-active chip is treated as an explicit manual
    // refresh and bypasses the cache for that run.
    loadDashboardBasedOnPeriod (curChip = this.enableChip, forceRefresh = false) {
      var isManualRefresh = forceRefresh || (!!this.enableChip && curChip === this.enableChip)
      this._pendingChip = curChip
      this._pendingForceRefresh = this._pendingForceRefresh || isManualRefresh
      if (this._dashboardFilterTimer) {
        clearTimeout(this._dashboardFilterTimer)
        this._dashboardFilterTimer = null
      }
      // invalidate the currently running/in-flight request right away, regardless of throttle
      dashboardScheduler.invalidateCurrentRun('Facdash filter changed')
      var runNow = () => {
        this._dashboardFilterTimer = null
        var chipToRun = this._pendingChip
        var refreshToRun = this._pendingForceRefresh
        this._pendingForceRefresh = false
        this.applyDashboardPeriod(chipToRun, refreshToRun)
      }
      if (!this._dashboardHasLoadedOnce) {
        this._dashboardHasLoadedOnce = true
        runNow()
        return
      }
      this._dashboardFilterTimer = setTimeout(runNow, this.dashboardFilterThrottleMs)
    },
    // Does the actual work of resolving a chip/period into concrete dates and (re)loading the
    // dashboard. Unchanged from the original loadDashboardBasedOnPeriod other than: recording
    // whether the resulting range is "live" (includes today) for TTL purposes, and threading
    // through the forceRefresh flag for cache bypass.
    applyDashboardPeriod (curChip, forceRefresh) {
      // find the period based on selection
      this.enableChip = curChip
      this.fromDate = this.toDate = null
      var curDate = new Date()
      if (curChip === 'Today') {
        this.fromDate = this.toDate = curDate
        this.aDay = true
        this.aWeek = false
      } else if (curChip === 'Yesterday') {
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - 1))
        this.toDate = this.fromDate
        this.aDay = true
        this.aWeek = false
      } else if (curChip === 'This Week') {
        this.toDate = new Date()
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - (curDate.getDay() - 1)))
        this.aDay = false
        this.aWeek = true
      } else if (curChip === 'Last Week') {
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - 7 - (curDate.getDay() - 1)))
        this.toDate = new Date(curDate.setDate(curDate.getDate() + 6))
        this.aDay = false
        this.aWeek = true
      } else if (curChip === 'This Month') {
        this.fromDate = new Date(curDate.getFullYear(), curDate.getMonth(), 1)
        this.toDate = curDate
        this.aDay = false
        this.aWeek = false
      } else if (curChip === 'Last Month') {
        curDate.setDate(1)
        this.fromDate = new Date(curDate.setMonth(curDate.getMonth() - 1))
        this.toDate = new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0)
        this.aDay = false
        this.aWeek = false
      } else {
        if (this.periodTo < this.periodFrom) {
          this.msg('From date has to be less than or equal to To date', 0)
          return
        }
        this.fromDate = new Date(this.periodFrom)
        this.toDate = new Date(this.periodTo)
        this.aDay = this.periodFrom === this.periodTo
      }
      // derive the trend
      if (this.aDay) {
        this.trendFrom = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth(), 1)
        this.trendTo = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth() + 1, 0)
      } else {
        this.trendFrom = this.fromDate
        this.trendTo = this.toDate
      }
      // a range that ends today (or later, e.g. a future Period end) is "live" -- its data can
      // still change -- everything else is historical/immutable and can be cached indefinitely
      this.isLiveRange = handy.formatDBDate(this.toDate) >= handy.formatDBDate(new Date())
      // convert the period into required format
      this.fromDate = handy.formatDBDate(this.fromDate)
      this.toDate = handy.formatDBDate(this.toDate)
      this.trendFrom = handy.formatDBDate(this.trendFrom) + ' 00:00:00'
      this.trendTo = handy.formatDBDate(this.trendTo) + ' 23:59:59'
      // drive this run's caching: historical data is cached indefinitely, live data gets a
      // short TTL, and an explicit refresh (re-clicking the active chip, or the auto-refresh
      // timer) bypasses the cache entirely for this pass
      this._currentCacheTtlMs = this.isLiveRange ? this.dashboardLiveCacheTtlMs : this.dashboardHistoricalCacheTtlMs
      dashboardScheduler.setForceRefresh(!!forceRefresh)
      // refresh the dashboard
      this.loadDailyDashboardSummary()
    },
    loadAttChart () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: this.aDay ? this.fromDate + ' 00:00:00' : this.trendFrom,
          to_dt: this.aDay ? this.toDate + ' 23:59:59' : this.trendTo,
          group_by: 'date',
          is_billable: 1
        }
      }
      return this.fetchDashboardApi('loadAttChart', config.API_URL + '/getAttendanceRep/', qry,
      response => {
        var dtLbl = [] // x-axis dates
        var avgVal = []
        var totPr = 0
        var totFL = 0
        var totLeave = 0
        var totWO = 0
        var totOT = 0
        var totPend = 0
        var totStaff = 0
        var totHoliday = 0
        // trend chart
        for (var i = 0; i < response.data.length; i++) {
          // pre-processing
          response.data[i].tot_present = response.data[i].tot_present + (response.data[i].tot_hd / 2)
          response.data[i].tot_absent = response.data[i].tot_absent + (response.data[i].tot_hd / 2)
          // for graph
          dtLbl[i] = handy.formatDBDate(response.data[i].att_dt)
          avgVal[i] = Math.round((response.data[i].tot_present + response.data[i].tot_wo + response.data[i].tot_ot + response.data[i].tot_hd) / response.data[i].total_staff * 100)
          // for dashboard summary
          if (response.data[i].total_staff) {
            totStaff += response.data[i].total_staff
          }
          if (response.data[i].tot_present) {
            totPr += response.data[i].tot_present
          }
          if (response.data[i].tot_absent) {
            totFL += response.data[i].tot_absent
          }
          if (response.data[i].tot_leave) {
            totLeave += response.data[i].tot_leave
          }
          if (response.data[i].tot_wo) {
            totWO += response.data[i].tot_wo
          }
          if (response.data[i].tot_ot) {
            totOT += response.data[i].tot_ot
          }
          if (response.data[i].tot_holiday) {
            totHoliday += response.data[i].tot_holiday
          }
          if (response.data[i].tot_pend) {
            totPend += response.data[i].tot_pend
          }
        }
        // summary
        if (this.aDay) {
          // find out the values of chosen day
          let didx = response.data.findIndex(rec => handy.formatDBDate(rec.att_dt) === handy.formatDBDate(this.fromDate + ' 00:00:00'))
          if (didx >= 0) {
            this.lAtt.tot_staff = response.data[didx].total_staff
            this.lAtt.tot_present = response.data[didx].tot_present
            this.lAtt.tot_leave = response.data[didx].tot_leave
            this.lAtt.tot_absent = response.data[didx].tot_absent
            this.lAtt.tot_wo = response.data[didx].tot_wo
            this.lAtt.tot_holiday = response.data[didx].tot_holiday
            this.lAtt.tot_ot = response.data[didx].tot_ot
            this.lAtt.tot_pend = response.data[didx].tot_pend
            this.lAtt.attAve = Math.round((this.lAtt.tot_present + this.lAtt.tot_wo + this.lAtt.tot_ot + this.lAtt.tot_holiday) / this.lAtt.tot_staff * 100)
          }
        } else {
          this.lAtt.tot_staff = totStaff
          this.lAtt.tot_present = totPr
          this.lAtt.tot_absent = totFL
          this.lAtt.tot_leave = totLeave
          this.lAtt.tot_wo = totWO
          this.lAtt.tot_holiday = totHoliday
          this.lAtt.tot_ot = totOT
          this.lAtt.tot_pend = totPend
          this.lAtt.attAve = Math.round((totPr + totWO + totOT + totHoliday) / totStaff * 100)
        }
        // reset for next date
        var dsets = []
        dsets[0] = {
          label: 'Attendance %',
          borderColor: 'rgba(0,0,255,0.8)',
          data: avgVal,
          fill: false
        }
        if (this.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_attend').innerHTML = '<canvas id="chart_attend"></canvas>'
          var canvas = document.getElementById('chart_attend')
          var ctx = canvas.getContext('2d')
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
      },
      err => {
        this.msg(err, 0)
      })
    },
    showAttendanceSummary () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: this.aDay ? this.fromDate : this.trendFrom,
          to_dt: this.aDay ? this.fromDate : this.trendTo,
          group_by: 'role',
          is_billable: 1
        }
      }
      this.attReport = []
      this.axios.get(config.API_URL + '/getAttendanceRep/', qry)
      .then(response => {
        this.attReport = response.data
        // calculate few fields below
        this.attReport.forEach(rec => {
          rec.staff_role = rec.staff_role + ' [' + rec.role_count + ']'
          rec.tot_present = rec.tot_present + (rec.tot_hd / 2)
          rec.tot_absent = rec.tot_absent + (rec.tot_hd / 2)
        })
        this.showSummary = true
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    loadComplianceOverall () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      return this.fetchDashboardApi('loadComplianceOverall', config.API_URL + '/getComplianceDashboard/overall/data', qry,
        response => {
          // Store the detailed data
          this.complianceDataActive = response.data.data.active || []
          this.complianceDataAboutToExpire = response.data.data.aboutToExpire || []
          this.complianceDataExpired = response.data.data.expired || []

          // Set counts from summary
          this.complianceOverall.ActiveCount = response.data.summary.activeCount
          this.complianceOverall.About_to_expiredCount = response.data.summary.aboutToExpireCount
          this.complianceOverall.ExpiredCount = response.data.summary.expiredCount

          // Calculate active percentage
          const total = this.complianceOverall.ActiveCount +
                       this.complianceOverall.About_to_expiredCount +
                       this.complianceOverall.ExpiredCount
          this.complianceOverall.activePercentage = total > 0
            ? Math.round((this.complianceOverall.ActiveCount / total) * 100)
            : 0

          // After loading data, create the chart
          this.$nextTick(() => {
            this.loadComplianceOverallChart()
          })
        },
        err => {
          this.msg('Error loading compliance overview', 0)
          console.error(err)
        })
    },
    loadComplianceByCategory () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      return this.fetchDashboardApi('loadComplianceByCategory', config.API_URL + '/getComplianceDashboard/data/byCategory/', qry,
        response => {
          this.complianceByCategory = response.data.summary
          this.complianceByCategoryData = response.data.data
          // After loading data, create the chart
          this.$nextTick(() => {
            this.loadComplianceCategoryChart()
          })
        },
        err => {
          this.msg('Error loading compliance by category', 0)
          console.error(err)
        })
    },
    loadComplianceCategoryChart () {
      // Clear previous chart if exists
      if (document.getElementById('chart_compliance_category')) {
        document.getElementById('div_compliance_category_chart').innerHTML =
          '<canvas id="chart_compliance_category"></canvas>'
      }

      // Final displayed categories after grouping
      var categories = Object.keys(this.displayedComplianceByCategory)
      var counts = Object.values(this.displayedComplianceByCategory)

      // Assign colors dynamically and store for legend
      var self = this
      self.categoryColorsForLegend = {}
      var colors = categories.map(function (catName, index) {
        var color = 'rgba(' + COLORS[index % COLORS.length] + ',0.8)'
        self.categoryColorsForLegend[catName] = color
        return color
      })
      // Get canvas context
      var canvas = document.getElementById('chart_compliance_category')
      if (!canvas) return
      canvas.style.cursor = 'pointer'
      var ctx = canvas.getContext('2d')

      // Create doughnut chart
      this.complianceCategoryChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: categories,
          datasets: [{
            data: counts,
            backgroundColor: colors,
            borderWidth: 2,
            borderColor: '#fff'
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 1,
          legend: { display: false },
          plugins: { datalabels: { display: false } },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var label = data.labels[tooltipItem.index]
                var value = data.datasets[0].data[tooltipItem.index]
                var total = data.datasets[0].data.reduce(function (a, b) { return a + b }, 0)
                var percentage = Math.round((value / total) * 100)
                return label + ': ' + value + ' (' + percentage + '%)'
              }
            }
          },
          onClick: function (event, activeElements) {
            if (activeElements && activeElements.length > 0) {
              var index = activeElements[0]._index
              var categoryName = categories[index]
              self.showCategoryDetails(categoryName)
            }
          }
        }
      })
    },
    loadComplianceOverallChart () {
      // Clear previous chart if exists
      if (document.getElementById('chart_compliance_overall')) {
        document.getElementById('div_compliance_overall_chart').innerHTML =
          '<canvas id="chart_compliance_overall"></canvas>'
      }

      var activeCount = this.complianceOverall.ActiveCount || 0
      var expiringCount = this.complianceOverall.About_to_expiredCount || 0
      var expiredCount = this.complianceOverall.ExpiredCount || 0
      var total = activeCount + expiringCount + expiredCount

      // If no data, don't render chart
      if (total === 0) return

      var labels = ['Active', 'Expiring Soon', 'Expired']
      var data = [activeCount, expiringCount, expiredCount]
      var colors = ['rgba(56, 142, 60, 0.95)', 'rgba(245, 124, 0, 0.95)', 'rgba(211, 47, 47, 0.95)']

      var canvas = document.getElementById('chart_compliance_overall')
      if (!canvas) return
      canvas.style.cursor = 'pointer'
      var ctx = canvas.getContext('2d')

      var self = this
      var overallChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: labels,
          datasets: [{
            data: data,
            backgroundColor: colors,
            borderWidth: 0
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 1,
          legend: { display: false },
          plugins: {
            datalabels: {
              color: '#fff',
              font: { weight: 'bold', size: 14 },
              formatter: function (value, ctx) {
                var percentage = Math.round((value / total) * 100)
                return percentage > 0 ? percentage + '%' : ''
              }
            }
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var label = data.labels[tooltipItem.index]
                var value = data.datasets[0].data[tooltipItem.index]
                var percentage = Math.round((value / total) * 100)
                return label + ': ' + value + ' (' + percentage + '%)'
              }
            }
          },
          onClick: function (event, activeElements) {
            if (activeElements && activeElements.length > 0) {
              var index = activeElements[0]._index
              var statusMap = ['active', 'aboutToExpire', 'expired']
              self.showComplianceDetails(statusMap[index])
            }
          }
        }
      })
      // Store reference if needed
      if (overallChart) {
        // Chart created successfully
      }
    },
    calculateCategoryDistributionPercentage (count) {
      const total = Object.values(this.displayedComplianceByCategory).reduce((a, b) => a + b, 0)
      return total > 0 ? Math.round((count / total) * 100) : 0
    },
    getCategoryDistributionColor (catName, index) {
      const colorMap = {
        'Legal': 'rgba(54,96,146,0.8)',
        'Environmental': 'rgba(118,146,60,0.8)',
        'Safety': 'rgba(227,108,9,0.8)',
        'Fire Safety': 'rgba(149,55,52,0.8)',
        'Health': 'rgba(95,73,122,0.8)',
        'Others': 'rgba(49,133,155,0.8)'
      }

      // Return predefined color or generate from COLORS array
      if (colorMap[catName]) {
        return colorMap[catName]
      }

      // Use existing COLORS array with index
      const colorIndex = index % COLORS.length
      return `rgba(${COLORS[colorIndex]},0.8)`
    },
    getOverallColor (overall) {
      return 'green'
    },
    loadComplianceCategoryStatus () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      var self = this
      return this.fetchDashboardApi('loadComplianceCategoryStatus', config.API_URL + '/getComplianceDashboard/categoryStatus', qry,
        function (response) {
          self.complianceCategoryStatus = response.data
          self.$nextTick(function () {
            self.loadComplianceCategoryStatusCharts()
          })
        },
        function (err) {
          self.msg('Error loading compliance category status', 0)
          console.error(err)
        })
    },
    calculateCategoryPercentage (catData) {
      if (!catData) return 0
      var total = catData.ActiveCount + catData.About_to_expiredCount + catData.ExpiredCount
      return total > 0 ? Math.round((catData.ActiveCount / total) * 100) : 0
    },
    getCategoryColor (catData) {
      if (!catData) return 'grey'
      var percentage = this.calculateCategoryPercentage(catData)
      if (percentage >= 80) return 'green'
      if (percentage >= 60) return 'orange'
      return 'red'
    },
    getCategoryCanvasId (catName) {
      // Sanitize category name for use as DOM ID
      return catName.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '')
    },
    loadComplianceCategoryStatusCharts () {
      var self = this
      // Render a doughnut chart for each category showing active/expiring/expired breakdown
      Object.keys(this.displayedComplianceCategoryStatus).forEach(function (catName) {
        var catData = self.displayedComplianceCategoryStatus[catName]
        var canvasId = 'chart_compliance_cat_' + self.getCategoryCanvasId(catName)
        var divId = 'div_compliance_cat_' + self.getCategoryCanvasId(catName)

        // Clear previous chart if exists
        var divElement = document.getElementById(divId)
        if (divElement) {
          divElement.innerHTML = '<canvas id="' + canvasId + '"></canvas>'
        }

        var canvas = document.getElementById(canvasId)
        if (!canvas) return

        var activeCount = catData.ActiveCount || 0
        var expiringCount = catData.About_to_expiredCount || 0
        var expiredCount = catData.ExpiredCount || 0
        var total = activeCount + expiringCount + expiredCount

        // If no data, don't render chart
        if (total === 0) return

        var ctx = canvas.getContext('2d')
        var data = [activeCount, expiringCount, expiredCount]
        var colors = ['rgba(56, 142, 60, 0.95)', 'rgba(245, 124, 0, 0.95)', 'rgba(211, 47, 47, 0.95)']

        var categoryChart = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: ['Active', 'Expiring', 'Expired'],
            datasets: [{
              data: data,
              backgroundColor: colors,
              borderWidth: 0
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            aspectRatio: 1,
            legend: { display: false },
            layout: {
              padding: {
                top: 10,
                bottom: 10,
                left: 10,
                right: 10
              }
            },
            plugins: {
              datalabels: {
                display: false
              }
            },
            tooltips: {
              enabled: true,
              mode: 'nearest',
              intersect: true,
              position: 'nearest',
              bodySpacing: 4,
              xPadding: 10,
              yPadding: 10,
              caretPadding: 10,
              displayColors: true,
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              titleFontSize: 12,
              bodyFontSize: 11,
              callbacks: {
                title: function (tooltipItem, data) {
                  return catName
                },
                label: function (tooltipItem, data) {
                  var label = data.labels[tooltipItem.index]
                  var value = data.datasets[0].data[tooltipItem.index]
                  var percentage = Math.round((value / total) * 100)
                  return label + ': ' + value + ' (' + percentage + '%)'
                }
              }
            }
          }
        })
        // Store reference if needed
        if (categoryChart) {
          // Chart created successfully
        }
      })
    },
    showComplianceDetails (status) {
      // Set dialog title and data based on status
      if (status === 'active') {
        this.complianceDialogTitle = 'Active Compliances'
        this.complianceDetails = this.complianceDataActive
      } else if (status === 'aboutToExpire') {
        this.complianceDialogTitle = 'Expiring Soon'
        this.complianceDetails = this.complianceDataAboutToExpire
      } else if (status === 'expired') {
        this.complianceDialogTitle = 'Expired Compliances'
        this.complianceDetails = this.complianceDataExpired
      }

      // Open the dialog
      this.complianceDialog = true
    },
    showCategoryDetails (categoryName) {
      // Set dialog title and data based on category
      this.categoryDialogTitle = `${categoryName} - Compliance Details`

      // Handle "Others" category - combine all categories not in top 3
      if (categoryName === 'Others') {
        const categories = Object.entries(this.complianceByCategory)
        const maxIndividual = 3

        // Get top 3 category names
        const topThreeNames = categories.slice(0, maxIndividual).map(([name]) => name)

        // Combine data from all categories NOT in the top 3
        this.categoryDetails = []
        Object.keys(this.complianceByCategoryData).forEach(catName => {
          // If this category is not in the top 3, include it in "Others"
          if (!topThreeNames.includes(catName) && this.complianceByCategoryData[catName]) {
            this.categoryDetails = this.categoryDetails.concat(this.complianceByCategoryData[catName])
          }
        })
      } else {
        // Regular category - show its data directly
        this.categoryDetails = this.complianceByCategoryData[categoryName] || []
      }

      // Open the dialog
      this.categoryDialog = true
    },
    showComplianceDetail () {
      // Show all compliance summary dialog
      this.showAllCompliance = true
    },
    loadWaterLevelChart () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: this.aDay ? this.fromDate + ' 00:00:00' : this.trendFrom,
          to_dt: this.aDay ? this.toDate + ' 23:59:59' : this.trendTo
        }
      }
      return this.fetchDashboardApi('loadWaterLevelChart', config.API_URL + '/getWaterLevelChartDetailsByCommId/', qry,
      response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var watTypeLbl = []
        var levelVal = {}
        var gw = 0
        var dtLbl = [] // for trend chart
        var levelAvgVal = {}
        var waterLvlKl = {}
        var gd = 0
        var idx = 0
        for (var i = 0; i < resObj.length; i++) {
          watTypeLbl[gw] = resObj[i].storage_nm
          levelVal[gw] = []
          levelAvgVal[gw] = []
          idx = gw++
          var lvl = resObj[i].levels
          for (var d = 0; d < lvl.length; d++) {
            if (lvl[d].water_level === '') {
              lvl[d].water_level = 0
            }
            var didx = dtLbl.indexOf(handy.formatDate(lvl[d].c_date))
            if (didx < 0 && lvl[d].c_date) {
              dtLbl[gd] = handy.formatDate(lvl[d].c_date)
              didx = gd++
            }
            if (this.aDay) {
              if (dtLbl[didx] === handy.formatDate(this.fromDate + ' 00:00:00')) {
                if (lvl[d].water_level) {
                  levelVal[idx][i] = lvl[d].water_level // show specific data for the day in first graph in case of single date
                }
                if (lvl[d].water_level_kl) {
                  waterLvlKl[i] = lvl[d].water_level_kl + ' KL'
                }
              }
            } else {
              if (!levelVal[idx][i]) {
                levelVal[idx][i] = 0
              }
              levelVal[idx][i] += Number(lvl[d].water_level)
            }
            if (!levelAvgVal[idx][didx]) {
              levelAvgVal[idx][didx] = 0
            }
            levelAvgVal[idx][didx] = Number(lvl[d].water_level)
          }
          if (!this.aDay) {
            levelVal[idx][i] /= lvl.length // show average in first graph in case of period
            levelVal[idx][i] = levelVal[idx][i].toFixed(0)
          }
        }
        // chart 1
        // data set
        var value = []
        for (i = 0; i < watTypeLbl.length; i++) {
          value.push(levelVal[i][i])
        }
        // clear the content if any
        document.getElementById('div_watlvl').innerHTML = '<canvas id="chart_watlvl"></canvas>'
        var canvas = document.getElementById('chart_watlvl')
        canvas.height = watTypeLbl.length > 2 ? watTypeLbl.length * 30 : watTypeLbl.length * 50
        var ctx = canvas.getContext('2d')
        this.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: watTypeLbl,
            datasets: [{
              backgroundColor: 'rgba(' + COLORS[1] + ',0.7)',
              data: value,
              fill: true
            }]
          },
          options: {
            tooltips: {enabled: false},
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  min: 0
                }
              }]
            },
            hover: {
              animationDuration: 0
            },
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return value + '%' || ''
                },
                color: '#ffffff'
              }
            }
          }
        })

        // chart 2
        var dsets2 = []
        for (i = 0; i < watTypeLbl.length; i++) {
          dsets2[i] = {
            label: watTypeLbl[i] + ' (%)',
            backgroundColor: 'rgba(' + COLORS[1] + ',0.1)',
            borderColor: 'rgba(' + COLORS[i] + ',1)',
            data: levelAvgVal[i],
            fill: true
          }
        }
        if (this.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_watlvltrend').innerHTML = '<canvas id="chart_watlvltrend"></canvas>'
          canvas = document.getElementById('chart_watlvltrend')
          var ctx2 = canvas.getContext('2d')

          this.tmpChart2 = new Chart(ctx2, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets2
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
        this.$forceUpdate()
      },
      err => {
        this.msg(err, 0)
      })
    },
    loadWaterConsType () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      return this.fetchDashboardApi('loadWaterConsType', config.API_URL + '/getWaterStorageByCommId/', qry,
        response => {
          this.waterConsTypeList = response.data.map(rec => rec.storage_nm)
          this.waterConsType = this.waterConsTypeList[0]
          // water level trend over a day
          this.storageNmListWithWaterLvl = response.data.filter(rec => rec.is_level_checked === 1)
          if (this.storageNmListWithWaterLvl.length > 0) {
            this.selectedStorageNmWithWaterLvl = this.storageNmListWithWaterLvl[0].storage_id
          }
          // water consumption trend over a day
          this.storageNmListWithWaterCons = response.data.filter(rec => rec.is_receipt_checked === 1 || rec.is_cons_checked === 1)
          if (this.storageNmListWithWaterCons.length > 0) {
            this.selectedStorageNmWithWaterCons = this.storageNmListWithWaterCons[0].storage_id
          }
        },
        err => {
          this.msg(err.response.data, true)
        })
    },
    loadWaterConsChart () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: this.aDay ? this.fromDate + ' 00:00:00' : this.trendFrom,
          to_dt: this.aDay ? this.toDate + ' 23:59:59' : this.trendTo,
          comingFrom: 'Facdash',
          water_cat: this.choosenType
        }
      }
      return this.fetchDashboardApi('loadWaterConsChart', config.API_URL + '/getWaterConsChartDetailsByCommId/', qry,
      response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var watTypeLbl = []
        var recVal = {}
        var dtLbl = [] // for trend chart
        var recAvgVal = {}
        var didx = 0
        var widx = 0
        var custWatType = this.waterConsType
        var modeLbl = ['Received (KL)', 'Consumed (KL)']
        recVal[0] = []
        recVal[1] = []
        recAvgVal[0] = []
        recAvgVal[1] = []
        this.tankerVal = 0
        this.receivedVal = 0
        this.consumedVal = 0
        for (var r = 0; r < resObj.length; r++) {
          var cons = resObj[r].cons
          for (var d = 0; d < cons.length; d++) {
            didx = dtLbl.indexOf(handy.formatDBDate(cons[d].c_date))
            if (didx < 0 && cons[d].c_date) {
              didx = dtLbl.length
              dtLbl[didx] = handy.formatDBDate(cons[d].c_date)
            }
            widx = watTypeLbl.indexOf(resObj[r].storage_nm.substring(0, 10))
            if (widx < 0) {
              widx = watTypeLbl.length
              watTypeLbl[widx] = resObj[r].storage_nm.substring(0, 10)
            }
            if (this.aDay) {
              // show specefic data for the day in first graph in case of single date
              if (dtLbl[didx] === handy.formatDBDate(this.fromDate + ' 00:00:00')) {
                if (!recVal[0][widx]) {
                  recVal[0][widx] = 0
                }
                if (cons[d].water_receipt) {
                  this.receivedVal += cons[d].water_receipt
                }
                recVal[0][widx] += cons[d].water_cons
              }
            } else {
              if (!recVal[0][widx]) {
                recVal[0][widx] = 0
              }
              if (cons[d].water_receipt) {
                this.receivedVal += cons[d].water_receipt
              }
              recVal[0][widx] += Number(cons[d].water_cons)
              recVal[1][widx] += Number(cons[d].water_receipt)
            }
            // worry about trend of only user chosen water type
            if (custWatType === resObj[r].storage_nm) {
              if (recAvgVal[0][didx] === undefined || recAvgVal[1][didx] === undefined) {
                recAvgVal[0][didx] = 0
                recAvgVal[1][didx] = 0
              }
              recAvgVal[0][didx] += Number(cons[d].water_receipt)
              recAvgVal[1][didx] += Number(cons[d].water_cons)
            }
          }
        }
        // to do: when automated for mulitple timestamps on the same day
        // chart 1 (water receipt and cons)
        // data set
        var dsets = []
        for (var j = 0; j < recVal[0].length; j++) {
          recVal[0][j] = recVal[0][j] > 0 ? recVal[0][j].toFixed(0) : 0
          this.consumedVal += Number(recVal[0][j])
        }
        dsets[0] = {
          label: modeLbl[1],
          backgroundColor: 'rgba(' + COLORS[4] + ',.7)',
          borderColor: 'rgba(' + COLORS[4] + ',1)',
          data: recVal[0],
          fill: true
        }
        // clear the content if any
        document.getElementById('div_watcons').innerHTML = '<canvas id="chart_watcons"></canvas>'
        var canvas = document.getElementById('chart_watcons')
        canvas.height = watTypeLbl.length > 4 ? watTypeLbl.length * 30 : watTypeLbl.length * 50
        var ctx = canvas.getContext('2d')
        this.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: watTypeLbl,
            datasets: dsets
          },
          options: {
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return value > 0 ? value + ' KL' : ''
                },
                color: '#ffffff'
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            }
          }
        })
        // chart 2 (trend)
        var dsets2 = []
        for (var i = 0; i < modeLbl.length; i++) {
          for (j = 0; j < recAvgVal[i].length; j++) {
            recAvgVal[i][j] = recAvgVal[i][j] > 0 ? recAvgVal[i][j].toFixed(2) : 0
          }
          dsets2[i] = {
            label: modeLbl[i],
            backgroundColor: 'rgba(' + COLORS[(i === 0 ? i + 2 : i + 3)] + ',0.1)',
            borderColor: 'rgba(' + COLORS[(i === 0 ? i + 2 : i + 3)] + ',1)',
            data: recAvgVal[i],
            fill: false
          }
        }
        if (this.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_watconstrend').innerHTML = '<canvas id="chart_watconstrend"></canvas>'
          canvas = document.getElementById('chart_watconstrend')
          var ctx2 = canvas.getContext('2d')
          this.tmpChart2 = new Chart(ctx2, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets2
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
        this.$forceUpdate()
      },
      err => {
        this.msg(err, 0)
      })
    },
    loadWaterSources () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          c_date: handy.formatDBDate(this.fromDate + ' 00:00:00'),
          from_dt: this.fromDate,
          to_dt: this.toDate
        }
      }
      return this.fetchDashboardApi('loadWaterSources', config.API_URL + '/getWaterSourcesByCommIdAndcDate/', qry,
      response => {
        if (response.data.length > 0) {
          this.domWatList = response.data
        }
        this.$forceUpdate()
      },
      err => {
        this.msg(err, 0)
      })
    },
    loadWaterConsumptionBasedonChip (curChip) {
      this.choosenType = curChip
      this.loadWaterConsChart()
    },
    loadWaterQualChart () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: this.aDay ? this.fromDate + ' 00:00:00' : this.trendFrom,
          to_dt: this.aDay ? this.toDate + ' 23:59:59' : this.trendTo
        }
      }
      return this.fetchDashboardApi('loadWaterQualChart', config.API_URL + '/getDailyWaterQualityByCommId/', qry,
      response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var paramLbl = []
        var paramId = []
        var paramUoM = []
        var watTypeLbl = []
        var qualVal = {}
        var stdValMin = []
        var stdValMax = []
        var dtLbl = [] // for trend chart
        var avgWaterLbl = []
        var qualAvgVal = {}
        var didx = 0
        var widx = 0
        var pidx = 0
        var apidx = 0
        var dtIdx = 1
        var x = 0
        var custParamName = this.waterQualType
        for (var r = 0; r < resObj.length; r++) {
          didx = dtLbl.indexOf(handy.formatDBDate(resObj[r].c_date))

          if (didx < 0 && resObj[r].c_date) {
            didx = dtLbl.length
            dtLbl[didx] = handy.formatDBDate(resObj[r].c_date)
          }

          widx = watTypeLbl.indexOf(resObj[r].water_type)
          if (widx < 0) {
            widx = watTypeLbl.length
            watTypeLbl[widx] = resObj[r].water_type
            qualVal[widx] = []
          }

          pidx = paramId.indexOf(resObj[r].param_id)
          if (pidx < 0) {
            pidx = paramId.length
            paramId[pidx] = resObj[r].param_id
            paramLbl[pidx] = resObj[r].param_name
            qualAvgVal[pidx] = []
          }
          if (this.aDay) {
            // show specefic data for the day in first graph in case of single date - overwrite to latest value if multiple log is found
            if (dtLbl[didx] === this.fromDate) {
              qualVal[widx][pidx] = Number(resObj[r].val)
            }
          } else {
            if (qualVal[widx][pidx] === undefined) {
              qualVal[widx][pidx] = 0
            }
            qualVal[widx][pidx] += Number(resObj[r].val)
          }
          paramUoM[pidx] = resObj[r].uom
          stdValMin[pidx] = Number(resObj[r].std_val_min)
          stdValMax[pidx] = Number(resObj[r].std_val_max)

          // worry about trend of only user chosen parameter
          if (custParamName === resObj[r].param_name) {
            apidx = avgWaterLbl.indexOf(resObj[r].water_type)
            if (apidx < 0) {
              apidx = avgWaterLbl.length
              avgWaterLbl[apidx] = resObj[r].water_type
              qualAvgVal[apidx] = []
            }

            qualAvgVal[apidx][didx] = Number(resObj[r].val)
          }
        }
        // find ave
        if (!this.aDay) {
          for (var i = 0; i < watTypeLbl.length; i++) {
            for (var j = 0; j < paramLbl.length; j++) {
              if (qualVal[i][j] && qualVal[i][j] !== '  ') {
                x = resObj.filter(rec => rec.param_name === paramLbl[j]).length
                if (x > 1) {
                  qualVal[i][j] /= x
                }
                qualVal[i][j] = (Number.isInteger(qualVal[i][j]) || qualVal[i][j] > 50) ? qualVal[i][j].toFixed(0) : qualVal[i][j].toFixed(1)
              }
            }
          }
        }
        // chart 1
        this.watQualHead = [
          { text: 'PARAM', value: 'param_name', class: 'grey darken-1 white--text text-xs-center' }
        ]
        // params
        this.waterQualParamList = paramLbl
        if (!this.waterQualType) {
          this.waterQualType = this.waterQualParamList[0]
        }
        this.watList = []
        var minMax = ''
        for (i = 0; i < paramLbl.length; i++) {
          if (stdValMin[i] && stdValMax[i]) {
            minMax = stdValMin[i] + ' to ' + stdValMax[i]
          } else if (stdValMin[i]) {
            minMax = 'min ' + stdValMin[i]
          } else {
            minMax = 'max ' + stdValMax[i]
          }
          this.watList.push({
            param_name: paramLbl[i],
            param_value: '(' + paramUoM[i] + ') [' + minMax + ']',
            std_val_min: stdValMin[i],
            std_val_max: stdValMax[i],
            waterQualTypeValue: []
          })
        }
        // construct table headers dynamically
        for (i = 0; i < watTypeLbl.length; i++) {
          this.watQualHead.splice(dtIdx++, 0,
            {
              text: watTypeLbl[i] === 'SWIMMING POOL' ? 'S. POOL' : watTypeLbl[i], value: watTypeLbl[i], class: 'pl-2 pr-0 text-xs-center white--text ccolor' + (i + 1)
            }
          )
        }
        // construct value table for each parameter

        for (i = 0; i < paramLbl.length; i++) {
          for (j = 0; j < watTypeLbl.length; j++) {
            this.watList[i].waterQualTypeValue.push({
              val: qualVal[j][i] || ''
            })
          }
        }
        dtLbl.forEach(rec => {
          if (rec.length === 0) {
            qualAvgVal = {}
          }
        })
        this.waterTypeLebel = watTypeLbl
        // chart 2
        var watColor = 0
        var dsets2 = []
        for (i = 0; i < avgWaterLbl.length; i++) {
          watColor = watTypeLbl.indexOf(avgWaterLbl[i])
          dsets2[i] = {
            label: avgWaterLbl[i],
            backgroundColor: 'rgba(' + COLORS[watColor] + ', 0.1)',
            borderColor: 'rgba(' + COLORS[watColor] + ', 1)',
            data: qualAvgVal[i],
            fill: false
          }
        }
        if (this.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_watqualtrend').innerHTML = '<canvas id="chart_watqualtrend"></canvas>'
          var canvas = document.getElementById('chart_watqualtrend')
          var ctx2 = canvas.getContext('2d')
          this.tmpChart2 = new Chart(ctx2, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets2
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
      },
      err => {
        this.msg(err, 0)
      })
    },
    loadPowerConsChart () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: this.aDay ? this.fromDate + ' 00:00:00' : this.trendFrom,
          to_dt: this.aDay ? this.toDate + ' 23:59:59' : this.trendTo
        }
      }
      return this.fetchDashboardApi('loadPowerConsChart', config.API_URL + '/getPowerConsChartDetailsByCommId/', qry,
      response => {
        var resObjPow = response.data.filter(rec => rec.power_unit_cons !== -1)
        var resObjGen = response.data.filter(rec => rec.genset_unit_cons !== -1)
        var dtLbl = [] // for trend chart
        var recTrendVal = {}
        var recVal = 0
        recTrendVal[0] = []
        recTrendVal[1] = []
        recTrendVal[2] = []
        var powUnits = 0
        var genUnits = 0
        var totPowUnits = 0
        var totGenUnits = 0
        for (var r = 0; r < resObjPow.length; r++) {
          dtLbl[r] = handy.formatDBDate(resObjPow[r].c_date)
          recTrendVal[0][r] = Number(resObjPow[r].power_unit_cons.toFixed(0))

          if (this.aDay) {
            // show specefic data for the day in section 1
            if (dtLbl[r] === handy.formatDBDate(this.fromDate + ' 00:00:00')) {
              powUnits = Number(resObjPow[r].power_unit_cons.toFixed(0))
            }
          } else {
            recVal = recVal + Number(resObjPow[r].power_unit_cons.toFixed(0))
            totPowUnits = totPowUnits + Number(resObjPow[r].power_unit_cons.toFixed(0))
          }
        } // for every rec
        // genset
        for (r = 0; r < resObjGen.length; r++) {
          dtLbl[r] = handy.formatDBDate(resObjGen[r].c_date)
          recTrendVal[1][r] = Number(resObjGen[r].genset_unit_cons)
          if (this.aDay) {
            // show specefic data for the day in section 1
            if (dtLbl[r] === this.fromDate) {
              genUnits = Number(resObjGen[r].genset_unit_cons)
            }
          } else {
            recVal = recVal + Number(resObjGen[r].genset_unit_cons)
            totGenUnits = totGenUnits + Number(resObjGen[r].genset_unit_cons)
          }
        } // for every rec
        if (this.aDay) {
          this.powCons = powUnits
          this.genCons = genUnits
        } else {
          this.powCons = totPowUnits.toFixed(0)
          this.genCons = totGenUnits
        }
        if (this.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_powconstrend').innerHTML = '<canvas id="chart_powconstrend"></canvas>'
          var canvas = document.getElementById('chart_powconstrend')
          var ctx = canvas.getContext('2d')
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: [
                {
                  label: 'Electricity Board (units)',
                  backgroundColor: 'rgba(' + COLORS[2] + ',0.4)',
                  borderColor: 'rgba(' + COLORS[2] + ',1)',
                  data: recTrendVal[0],
                  fill: true
                },
                {
                  label: 'Genset (units)',
                  backgroundColor: 'rgba(' + COLORS[4] + ',0.4)',
                  borderColor: 'rgba(' + COLORS[4] + ',1)',
                  data: recTrendVal[1],
                  fill: false
                }
              ]
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
        this.$forceUpdate()
      },
      err => {
        this.msg(err, 0)
      })
    },
    loadDieselConsChart () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: this.aDay ? this.fromDate + ' 00:00:00' : this.trendFrom,
          to_dt: this.aDay ? this.toDate + ' 23:59:59' : this.trendTo
        }
      }
      return this.fetchDashboardApi('loadDieselConsChart', config.API_URL + '/getPowerGensetByCommIdAndcDate/', qry,
      response => {
        var resObj = response.data
        var modeLbl = ['Level (%)', 'Purchased (ltr)', 'Stock (ltr)']
        var genLbl = []
        var levelVal = {}
        var dtLbl = [] // for trend chart
        var recAvgVal = {}
        var didx = 0
        var gidx = 0

        var purVal = 0
        var stkVal = 0
        levelVal[0] = []
        levelVal[1] = []
        recAvgVal[0] = []
        recAvgVal[1] = []
        recAvgVal[2] = []
        for (var r = 0; r < resObj.length; r++) {
          didx = dtLbl.indexOf(handy.formatDBDate(resObj[r].c_date))
          if (didx < 0 && resObj[r].c_date) {
            didx = dtLbl.length
            dtLbl[didx] = handy.formatDBDate(resObj[r].c_date)
          }

          gidx = genLbl.indexOf(resObj[r].genset_nm)
          if (gidx < 0) {
            gidx = genLbl.length
            genLbl[gidx] = resObj[r].genset_nm
            levelVal[0][gidx] = 0
            levelVal[1][gidx] = 0
          }

          if (this.aDay) {
            // show specefic data for the day in section 1 (badge)
            if (dtLbl[didx] === handy.formatDBDate(this.fromDate + ' 00:00:00')) {
              levelVal[0][gidx] = Number(resObj[r].level)
              purVal += Number(resObj[r].purchased)
              stkVal += Number(resObj[r].stock)
            }
          } else {
            levelVal[0][gidx] += Number(resObj[r].level)
            purVal += Number(resObj[r].purchased)
            stkVal += Number(resObj[r].stock)
          }

          if (recAvgVal[0][didx] === undefined || recAvgVal[1][didx] === undefined || recAvgVal[2][didx] === undefined) {
            recAvgVal[0][didx] = 0
            recAvgVal[1][didx] = 0
            recAvgVal[2][didx] = 0
          }
          recAvgVal[0][didx] += Number(resObj[r].level) // total of all genset, average found later
          recAvgVal[1][didx] += Number(resObj[r].purchased)
          recAvgVal[2][didx] += Number(resObj[r].stock)
        } // for every rec
        // find ave
        if (!this.aDay) {
          // avg for level and stock only
          for (var i = 0; i < genLbl.length; i++) {
            levelVal[0][i] /= dtLbl.length
            levelVal[0][i] = levelVal[0][i].toFixed(0)
          }
          stkVal /= dtLbl.length
          stkVal = stkVal.toFixed(0)
        }
        // average for level in second graph
        for (i = 0; i < dtLbl.length; i++) {
          recAvgVal[0][i] /= genLbl.length
          recAvgVal[0][i] = recAvgVal[0][i].toFixed(0)
        }
        dtLbl.forEach(rec => {
          if (rec.length <= 0) {
            recAvgVal = {}
          }
        })
        // section 1
        // 1. cons
        this.diCons = purVal
        this.diStock = stkVal

        // 2. level
        // data set
        // clear the content if any
        document.getElementById('div_dicons').innerHTML = '<canvas id="chart_dicons"></canvas>'
        var canvas = document.getElementById('chart_dicons')
        var ctx = canvas.getContext('2d')
        this.tmpChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: genLbl,
            datasets: [{
              label: modeLbl[0],
              backgroundColor: 'rgba(' + COLORS[3] + ',0.7)',
              borderColor: 'rgba(' + COLORS[3] + ',1)',
              data: levelVal[0],
              fill: true
            }]
          },
          options: {
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return value ? value + ' %' : ''
                },
                color: '#ffffff'
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            }
          }
        })
        // chart 2
        if (this.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_diconstrend').innerHTML = '<canvas id="chart_diconstrend"></canvas>'
          canvas = document.getElementById('chart_diconstrend')
          var ctx2 = canvas.getContext('2d')
          this.tmpChart2 = new Chart(ctx2, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: [{
                label: modeLbl[0],
                backgroundColor: 'rgba(' + COLORS[3] + ',0.4)',
                borderColor: 'rgba(' + COLORS[3] + ',1)',
                data: recAvgVal[0],
                fill: true
              },
              {
                label: modeLbl[1],
                backgroundColor: 'rgba(' + COLORS[2] + ',0.4)',
                borderColor: 'rgba(' + COLORS[2] + ',1)',
                data: recAvgVal[1],
                fill: false
              },
              {
                label: modeLbl[2],
                backgroundColor: 'rgba(' + COLORS[4] + ',0.4)',
                borderColor: 'rgba(' + COLORS[4] + ',1)',
                data: recAvgVal[2],
                fill: false
              }]
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
      },
      err => {
        this.msg(err, 0)
      })
    },
    loadWasteChart () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: this.aDay ? this.fromDate + ' 00:00:00' : this.trendFrom,
          to_dt: this.aDay ? this.toDate + ' 23:59:59' : this.trendTo
        }
      }
      return this.fetchDashboardApi('loadWasteChart', config.API_URL + '/getWasteByCommIdAndcDate/', qry,
      response => {
        this.lWaste = response.data.filter(rec => handy.formatDBDate(rec.c_date) === handy.formatDBDate(this.fromDate + ' 00:00:00'))
        var resObj = response.data
        var wasteTypeLbl = []
        var recVal = {}
        var dtLbl = [] // for trend chart
        var recAvgVal = {}
        var didx = 0
        var widx = 0

        recVal[0] = []
        for (var r = 0; r < resObj.length; r++) {
          didx = dtLbl.indexOf(handy.formatDBDate(resObj[r].c_date))

          if (didx < 0 && resObj[r].c_date) {
            didx = dtLbl.length
            dtLbl[didx] = handy.formatDBDate(resObj[r].c_date)
          }

          widx = wasteTypeLbl.indexOf(resObj[r].waste_type)
          if (widx < 0) {
            widx = wasteTypeLbl.length
            wasteTypeLbl[widx] = resObj[r].waste_type
            recVal[widx] = []
            recAvgVal[widx] = []
          }
          if (this.aDay) {
            // show specefic data for the day in first graph in case of single date
            if (dtLbl[didx] === handy.formatDBDate(this.fromDate + ' 00:00:00')) {
              recVal[widx][0] = resObj[r].kgs
            }
          } else {
            if (recVal[widx][0] === undefined) {
              recVal[widx][0] = 0
            }
            recVal[widx][0] += Number(resObj[r].kgs)
          }
          // for trend
          if (recAvgVal[widx][didx] === undefined) {
            recAvgVal[widx][didx] = 0
          }
          recAvgVal[widx][didx] += resObj[r].kgs
        } // for every rec
        // chart 1
        // data set
        var dsets = []
        var lColor = ['0,255,0', '0,0,255', '255,0,0']
        for (var i = 0; i < wasteTypeLbl.length; i++) {
          dsets[i] = {
            label: wasteTypeLbl[i] + ' (kg)',
            backgroundColor: 'rgba(' + lColor[i] + ',0.4)',
            borderColor: 'rgba(' + lColor[i] + ',1)',
            data: recVal[i],
            fill: true
          }
        }
        // clear the content if any
        document.getElementById('div_waste').innerHTML = '<canvas id="chart_waste"></canvas>'
        var canvas = document.getElementById('chart_waste')
        var ctx = canvas.getContext('2d')
        this.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: ['Wastage (kg)'],
            datasets: dsets
          },
          options: {
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return value + ' kg'
                },
                color: '#ffffff'
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  min: 0
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        })

        // chart 2
        var dsets2 = []
        for (i = 0; i < wasteTypeLbl.length; i++) {
          dsets2[i] = {
            label: wasteTypeLbl[i] + ' (kg)',
            backgroundColor: 'rgba(' + lColor[i] + ',0.1)',
            borderColor: 'rgba(' + lColor[i] + ',1)',
            data: recAvgVal[i],
            fill: false
          }
        }
        if (this.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_wastetrend').innerHTML = '<canvas id="chart_wastetrend"></canvas>'
          canvas = document.getElementById('chart_wastetrend')
          var ctx2 = canvas.getContext('2d')
          this.tmpChart2 = new Chart(ctx2, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets2
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
      },
      err => {
        this.msg(err, 0)
      })
    },
    loadCustomMetricCat () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      return this.fetchDashboardApi('loadCustomMetricCat', config.API_URL + '/getCusMetByCommId/', qry,
        response => {
          this.metricCat = handy.unique(response.data.map(rec => rec.metric_cat))
        },
        err => {
          this.msg(err.response.data, true)
          this.metricCat = []
        })
    },
    loadOtherCustomMetricChart () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: this.aDay ? this.fromDate + ' 00:00:00' : this.trendFrom,
          to_dt: this.aDay ? this.toDate + ' 23:59:59' : this.trendTo
        }
      }
      return this.fetchDashboardApi('loadOtherCustomMetricChart', config.API_URL + '/getMetricByCommId/', qry,
      response => {
        var prevCat = ''
        var curCat = ''
        var curCatNoSpace = ''
        var resObj = response.data
        var idx = 0
        for (var i = 0; i < resObj.length; i = idx) {
          curCat = resObj[i].metric_cat
          prevCat = curCat
          curCatNoSpace = curCat.split(' ').join('_')
          var metNameLbl = []
          var totOrAve = []
          var recVal = []
          var dtLbl = [] // for trend chart
          var recAvgVal = {}
          var didx = 0
          var widx = 0

          recVal[0] = []
          for (var r = i; r < resObj.length; r++) {
            curCat = resObj[r].metric_cat
            if (curCat !== prevCat) {
              idx = r // finish this category and move to next category
              break
            } else {
              idx++
            }

            didx = dtLbl.indexOf(handy.formatDBDate(resObj[r].c_date))

            if (didx < 0 && resObj[r].c_date) {
              didx = dtLbl.length
              dtLbl[didx] = handy.formatDBDate(resObj[r].c_date)
            }
            widx = metNameLbl.indexOf(resObj[r].metric_nm)
            if (widx < 0) {
              widx = metNameLbl.length
              metNameLbl[widx] = resObj[r].metric_nm
              recVal[widx] = []
              totOrAve[widx] = resObj[r].period_display
              recAvgVal[widx] = []
            }
            if (this.aDay) {
              // show specefic data for the day in first graph in case of single date
              if (dtLbl[didx] === handy.formatDBDate(this.fromDate + ' 00:00:00')) {
                recVal[widx][0] = resObj[r].metric_val
              }
            } else {
              if (!recVal[widx][0]) {
                recVal[widx][0] = 0
              }
              recVal[widx][0] += Number(resObj[r].metric_val)
            }
            // for trend
            if (!recAvgVal[widx][didx]) {
              recAvgVal[widx][didx] = 0
            }
            recAvgVal[widx][didx] += resObj[r].metric_val
          } // for every rec
          dtLbl.forEach(rec => {
            if (rec.length <= 0) {
              recAvgVal = {}
            }
          })
          // chart 1
          // data set
          var dsets = []
          for (var c = 0; c < metNameLbl.length; c++) {
            // find avarage if this metric is configured to be displayed as average
            if (!this.aDay && totOrAve[c] === 'A') {
              recVal[c][0] /= dtLbl.length
              recVal[c][0] = recVal[c][0].toFixed(0)
              metNameLbl[c] = metNameLbl[c] + ' (Avg)'
            } else if (!this.aDay) {
              metNameLbl[c] = metNameLbl[c] + ' (Tot)'
            }
            dsets[c] = {
              label: metNameLbl[c],
              backgroundColor: 'rgba(' + COLORS[c % 5] + ',0.4)',
              borderColor: 'rgba(' + COLORS[c % 5] + ',1)',
              data: recVal[c],
              fill: true
            }
          }
          // clear the content if any
          document.getElementById('div_other_' + curCatNoSpace).innerHTML = '<canvas id="chart_other_' + curCatNoSpace + '"></canvas>'
          var canvas = document.getElementById('chart_other_' + curCatNoSpace)
          var ctx = canvas.getContext('2d')
          this.tmpChart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: [''],
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return value || ''
                  },
                  color: '#ffffff'
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              },
              hover: {
                animationDuration: 0
              }
            }
          })
          // chart 2
          var dsets2 = []
          for (var j = 0; j < metNameLbl.length; j++) {
            dsets2[j] = {
              label: metNameLbl[j],
              backgroundColor: 'rgba(' + COLORS[j % 5] + ',0.1)',
              borderColor: 'rgba(' + COLORS[j % 5] + ',1)',
              data: recAvgVal[j],
              fill: false
            }
          }
          if (this.enableTrend === true) {
            // clear the content if any
            document.getElementById('div_other_trend_' + curCatNoSpace).innerHTML = '<canvas id="chart_other_trend_' + curCatNoSpace + '"></canvas>'
            canvas = document.getElementById('chart_other_trend_' + curCatNoSpace)
            var ctx2 = canvas.getContext('2d')
            this.tmpChart2 = new Chart(ctx2, {
              type: 'line',
              data: {
                labels: dtLbl,
                datasets: dsets2
              },
              options: {
                plugins: {
                  datalabels: {
                    // hide datalabels for all datasets
                    display: false
                  }
                },
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                  display: false
                },
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero: true
                    }
                  }]
                }
              }
            })
          }
        }
      },
      err => {
        this.msg(err, 0)
      })
    },
    EnableTrend () {
      if (!this.enableTrend) {
        this.enableTrend = true
      } else {
        this.enableTrend = false
      }
      this.loadDailyDashboardSummary()
      this.$forceUpdate()
    },
    loadFacDailyUpdateAttachment () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: this.aDay && !this.enableTrend ? this.fromDate + ' 00:00:00' : this.trendFrom,
          to_dt: this.aDay && !this.enableTrend ? this.toDate + ' 23:59:59' : this.trendTo
        }
      }
      this.lDailyUpdateAttach.fileUrls = []
      this.lDailyUpdateAttach.files = []
      return this.fetchDashboardApi('loadFacDailyUpdateAttachment', config.API_URL + '/getAttachmentByCDate/', qry,
        response => {
          this.lDailyUpdateAttach.fileUrls = response.data
          this.lDailyUpdateAttach.cat = this.lDailyUpdateAttach.cat || 'All'
          if (this.lDailyUpdateAttach.cat === 'All') {
            this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls
          } else {
            this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === this.lDailyUpdateAttach.cat)
          }
          this.$forceUpdate()
        },
        err => {
          this.msg(err.response.data, 0)
          this.lDailyUpdateAttach.fileUrls = []
        })
    },
    loadCategoryImage (curcategory) {
      if (curcategory) {
        this.lDailyUpdateAttach.files = []
        this.lDailyUpdateAttach.cat = curcategory
        if (curcategory === 'All') {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls
        } else {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === curcategory)
        }
        this.$forceUpdate()
      }
    },
    loadPhotoCat () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      return this.fetchDashboardApi('loadPhotoCat', config.API_URL + '/getPhotoCatByCommId/', qry,
        response => {
          this.photoCatChips = response.data
          this.lDailyUpdateAttach.cat = this.photoCatChips[0].attach_cat_id
        },
        err => {
          this.msg(err, true)
        })
    },
    loadTrendOverADayBasedOnPeriod (curChip, curType, curWatType) {
      if (this.aDay) {
        if (curWatType) {
          this.waterQualiltyType = curWatType
        }
        // find the period based on selection
        this.enableTrendChip = curChip
        this.fromTime = this.toTime = null
        var curDate = new Date()
        if (curChip === 'Last 1 hr') {
          this.fromTime = handy.getTime(new Date(curDate.getTime() - (1000 * 60 * 60)))
          this.toTime = handy.getTime(new Date(curDate.getTime()))
        } else if (curChip === '6 hrs') {
          this.fromTime = handy.getTime(new Date(curDate.getTime() - (1000 * 60 * 60 * 6)))
          this.toTime = handy.getTime(new Date(curDate.getTime()))
        } else if (curChip === '12 hrs') {
          this.fromTime = handy.getTime(new Date(curDate.getTime() - (1000 * 60 * 60 * 12)))
          this.toTime = handy.getTime(new Date(curDate.getTime()))
        } else {
          this.fromTime = '00:00:00'
          this.toTime = '23:59:59'
        }
        // if fromtime is greater than toTime
        if (this.fromTime > this.toTime) {
          this.fromTime = '00:00:00'
        }
        // common values for quality and level
        if (this.enableChip === 'Yesterday') {
          this.fromDt = new Date(curDate.setDate(curDate.getDate() - 1))
          this.toDt = this.fromDt
        } else if (this.enableChip === 'Today') {
          this.fromDt = this.toDt = curDate
        } else if (this.enableChip === 'Period') {
          this.fromDt = this.fromDate
          this.toDt = this.toDate
        }
        // refresh the Trend over a day graph
        if (curType === 'Quality') {
          this.showWaterQualityOverADay()
        } else if (curType === 'Level') {
          this.showWaterLevelOverADay()
        } else if (curType === 'Cons') {
          this.showWaterConsOverADay()
        }
      }
      if (curType === 'Power') {
        if (!this.aDay) {
          this.fromDt = this.fromDate
          this.toDt = this.toDate
        }
        this.showPowerConsPieChart()
      }
    },
    showWaterQualityOverADay () {
      if (!this.waterQualiltyType) {
        this.waterQualiltyType = this.waterQualParamList[0]
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.fromDt),
          to_dt: handy.formatDBDate(this.toDt),
          from_time: this.fromTime,
          to_time: this.toTime
        }
      }
      this.axios.get(config.API_URL + '/getWaterQualityBasedOnADay/', qry)
      .then(response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var dtLbl = []
        var watQualAvgVal = []
        var paramNameLbl = []
        var avgWaterLbl = []
        var gd = 0
        var apidx = 0
        var custParamName = this.waterQualiltyType
        // trend chart
        for (var i = 0; i < resObj.length; i++) {
          // for every rec
          paramNameLbl[i] = resObj[i].param_name
          watQualAvgVal[i] = []
          // for graph
          var lvl = resObj[i].value
          for (var d = 0; d < lvl.length; d++) {
            if (lvl[d].val === '') {
              lvl[d].val = 0
            }
            // worry about trend of only user chosen parameter
            if ((custParamName === resObj[i].param_name)) {
              var didx = dtLbl.indexOf(handy.getTime12Hrs(lvl[d].c_date))
              if (didx < 0 && lvl[d].c_date) {
                dtLbl[gd] = handy.getTime12Hrs(lvl[d].c_date)
                didx = gd++
              }
              apidx = avgWaterLbl.indexOf(resObj[i].water_type)
              if (apidx < 0) {
                apidx = avgWaterLbl.length
                avgWaterLbl[apidx] = resObj[i].water_type
              }
              watQualAvgVal[apidx][didx] = Number(lvl[d].val)
            }
          }
        }
        for (var j = 0; j < paramNameLbl.length; j++) {
          // shorten the label
          if (paramNameLbl[j].length > 3) {
            paramNameLbl[j] = paramNameLbl[j].substring(0, 10)
          }
        }
        // chart 1
        // data set
        var watColor = 0
        var dsets = []
        for (i = 0; i < avgWaterLbl.length; i++) {
          watColor = this.waterTypeLebel.indexOf(avgWaterLbl[i])
          dsets[i] = {
            label: avgWaterLbl[i],
            backgroundColor: 'rgba(' + COLORS[watColor] + ', 0.1)',
            borderColor: 'rgba(' + COLORS[watColor] + ', 1)',
            data: watQualAvgVal[i],
            fill: false
          }
        }

        // clear the content if any
        setTimeout(() => {
          document.getElementById('div_watqualoveradaytrend').innerHTML = '<canvas id="chart_watqualoveradaytrend"></canvas>'
          var canvas = document.getElementById('chart_watqualoveradaytrend')
          canvas.height += avgWaterLbl.length * 30
          var ctx = canvas.getContext('2d')
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true,
                position: 'bottom'
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }, 500)
        this.qualityTrendOverADay = true
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showWaterLevelOverADay () {
      if (!this.selectedStorageNmWithWaterLvl) {
        this.selectedStorageNmWithWaterLvl = this.storageNmListWithWaterLvl[0].storage_id
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.fromDt) + ' ' + this.fromTime,
          to_dt: handy.formatDBDate(this.toDt) + ' ' + this.toTime,
          storage_id: this.selectedStorageNmWithWaterLvl
        }
      }
      this.axios.get(config.API_URL + '/getWaterLevelTrendOverAdayByStorageId/', qry)
      .then(response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var dtLbl = []
        var watLevelAvgVal = []
        var avgStorageLbl = []
        var gd = 0
        var apidx = 0
        var custStorageId = this.selectedStorageNmWithWaterLvl
        this.watTankBattery = null
        // trend chart
        for (var i = 0; i < resObj.length; i++) {
          watLevelAvgVal[i] = []
          var lvl = resObj[i].levels[0]
          for (var d = 0; d < lvl.length; d++) {
            if (!lvl[d].water_level) {
              lvl[d].water_level = 0
            }
            // worry about trend of only user chosen parameter
            if (custStorageId === resObj[i].storage_id) {
              if (lvl[d].dev_battery) {
                this.watTankBattery = lvl[d].dev_battery
              }
              var didx = dtLbl.indexOf(handy.getTime12Hrs(lvl[d].c_date))
              if (didx < 0 && lvl[d].c_date) {
                dtLbl[gd] = handy.getTime12Hrs(lvl[d].c_date)
                didx = gd++
              }
              apidx = avgStorageLbl.indexOf(resObj[i].storage_nm)
              if (apidx < 0) {
                apidx = avgStorageLbl.length
                avgStorageLbl[apidx] = resObj[i].storage_nm
              }
              watLevelAvgVal[apidx][didx] = Number(lvl[d].water_level)
            }
          }
        }
        // chart 1
        // data set
        var dsets = []
        for (i = 0; i < avgStorageLbl.length; i++) {
          dsets[i] = {
            label: avgStorageLbl[i],
            backgroundColor: 'rgba(' + COLORS[1] + ',0.5)',
            borderColor: 'rgba(' + COLORS[0] + ', 1)',
            data: watLevelAvgVal[i],
            fill: true
          }
        }
        // clear the content if any
        setTimeout(() => {
          document.getElementById('div_watlvloveradaytrend').innerHTML = '<canvas id="chart_watlvloveradaytrend"></canvas>'
          var canvas = document.getElementById('chart_watlvloveradaytrend')
          canvas.height += avgStorageLbl.length * 30
          var ctx = canvas.getContext('2d')
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }, 500)
        this.lvlTrendOverADay = true
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showPowerConsPieChart () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.fromDt),
          to_dt: handy.formatDBDate(this.toDt)
        }
      }
      this.axios.get(config.API_URL + '/getPowerMeterDailyRep/', qry)
      .then(response => {
        var resObj = response.data
        var areaLbl = []
        var unitConsVal = []
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          areaLbl[i] = resObj[i].area_covered
          unitConsVal[i] = 0
          if (!resObj[i].unit_cons) {
            resObj[i].unit_cons = 0
          }
          unitConsVal[i] += Number(resObj[i].unit_cons.toFixed(2))
        }
        var totZero = 0
        for (i = 0; i < unitConsVal.length; i++) {
          if (unitConsVal[i] === 0) {
            totZero++
          }
        }
        if (totZero === unitConsVal.length) {
          this.nodata = true
        } else {
          this.nodata = false
        }
        // chart 1
        // clear the content if any
        if (this.nodata) {
          setTimeout(() => {
            document.getElementById('div_powconstrendoveraday').innerHTML = 'No data available'
          }, 500)
          this.$forceUpdate()
        } else {
          setTimeout(() => {
            document.getElementById('div_powconstrendoveraday').innerHTML = '<canvas id="chart_powconstrendoveraday"></canvas>'
            var canvas = document.getElementById('chart_powconstrendoveraday')
            var ctx = canvas.getContext('2d')
            ctx.canvas.height = areaLbl.length * 18
            ctx.canvas.width = areaLbl.length * 20
            this.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: areaLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429', '#5f4170', '#4c646e'],
                  data: unitConsVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function (value) {
                      return value
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  text: 'Electricity Board (Units)'
                },
                legend: {
                  position: 'bottom'
                }
              }
            })
          }, 500)
        }
        this.showPowerConstrendOverADay = true
        this.showPowerGensetPieChart()
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showPowerGensetPieChart () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.fromDt),
          to_dt: handy.formatDBDate(this.toDt)
        }
      }
      this.axios.get(config.API_URL + '/getPowerGensetPieChartByCommId/', qry)
      .then(response => {
        var resObj = response.data
        var gensetLbl = []
        var unitConsVal = []
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          gensetLbl[i] = resObj[i].genset_nm
          var unitVal = resObj[i].value
          unitConsVal[i] = 0
          for (var d = 0; d < unitVal.length; d++) {
            if (!unitVal[d].units_cons) {
              unitVal[d].units_cons = 0
            }
            unitConsVal[i] += Number(unitVal[d].units_cons)
          }
        }
        var totZero = 0
        for (i = 0; i < unitConsVal.length; i++) {
          if (unitConsVal[i] === 0) {
            totZero++
          }
        }
        if (totZero === unitConsVal.length) {
          this.nodata = true
        } else {
          this.nodata = false
        }
        // chart 1
        // clear the content if any
        if (this.nodata) {
          setTimeout(() => {
            document.getElementById('div_powgensettrendoveraday').innerHTML = 'No data available'
          }, 500)
          this.$forceUpdate()
        } else {
          setTimeout(() => {
            document.getElementById('div_powgensettrendoveraday').innerHTML = '<canvas id="chart_powgensettrendoveraday"></canvas>'
            var canvas = document.getElementById('chart_powgensettrendoveraday')
            var ctx = canvas.getContext('2d')
            ctx.canvas.height = gensetLbl.length * 17
            ctx.canvas.width = gensetLbl.length * 20
            this.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: gensetLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429'],
                  data: unitConsVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function (value) {
                      return value
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  text: 'Genset (Units)'
                },
                legend: {
                  position: 'bottom'
                }
              }
            })
          }, 500)
          this.$forceUpdate()
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showWaterConsOverADay () {
      if (!this.selectedStorageNmWithWaterCons) {
        this.selectedStorageNmWithWaterCons = this.storageNmListWithWaterCons[0].storage_id
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.fromDt) + ' ' + this.fromTime,
          to_dt: handy.formatDBDate(this.toDt) + ' ' + this.toTime,
          storage_id: this.selectedStorageNmWithWaterCons
        }
      }
      this.axios.get(config.API_URL + '/getWaterConsTrendOverAdayByStorageId/', qry)
      .then(response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var dtLbl = []
        var didx = []
        var widx = []
        var recAvgVal = {}
        var avgStorageLbl = []
        var modeLbl = ['In-flow (KL)', 'Out-flow (KL)']
        recAvgVal[0] = []
        recAvgVal[1] = []
        var cons = []
        var custStorageId = this.selectedStorageNmWithWaterCons
        // trend chart
        for (var r = 0; r < resObj.length; r++) {
          widx = avgStorageLbl.indexOf(resObj[r].storage_id)
          if (widx < 0) {
            widx = avgStorageLbl.length
            avgStorageLbl[widx] = resObj[r].storage_nm.substring(0, 10)
          }
          cons = resObj[r].cons[0]
          for (var i = 0; i < cons.length; i++) {
            didx = dtLbl.indexOf(handy.getTime12Hrs(cons[i].c_date))
            if (didx < 0 && cons[i].c_date) {
              didx = dtLbl.length
              dtLbl[didx] = handy.getTime12Hrs(cons[i].c_date)
            }
            // worry about trend of only user chosen water type
            if (custStorageId === resObj[r].storage_id) {
              if (!recAvgVal[0][didx] || !recAvgVal[1][didx]) {
                recAvgVal[0][didx] = 0
                recAvgVal[1][didx] = 0
              }
              recAvgVal[0][didx] += cons[i].water_receipt
              recAvgVal[1][didx] += cons[i].water_cons
            }
          }
        } // for every rec
        // chart 1
        // data set
        var dsets = []
        for (i = 0; i < modeLbl.length; i++) {
          dsets[i] = {
            label: modeLbl[i],
            backgroundColor: 'rgba(' + COLORS[(i === 0 ? i + 2 : i + 3)] + ',0.1)',
            borderColor: 'rgba(' + COLORS[(i === 0 ? i + 2 : i + 3)] + ',1)',
            data: recAvgVal[i],
            fill: true
          }
        }
        // clear the content if any
        setTimeout(() => {
          document.getElementById('div_watConsoveradaytrend').innerHTML = '<canvas id="chart_watConsoveradaytrend"></canvas>'
          var canvas = document.getElementById('chart_watConsoveradaytrend')
          canvas.height += avgStorageLbl.length * 30
          var ctx = canvas.getContext('2d')
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }, 500)
        this.consTrendOverADay = true
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadHygieneCat () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      return this.fetchDashboardApi('loadHygieneCat', config.API_URL + '/getSanCheckCatByCommId/', qry,
        response => {
          this.hygCats = response.data
          return this.loadHygiene()
        },
        err => {
          this.msg(err, true)
        })
    },
    loadHygiene () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: !this.aDay ? handy.formatDBDate(this.trendFrom) : this.fromDate,
          to_dt: !this.aDay ? handy.formatDBDate(this.trendFrom) : this.fromDate
        }
      }
      this.hygList = []
      return this.fetchDashboardApi('loadHygiene', config.API_URL + '/getSanCheckByCommIdAndcDate/', qry,
        response => {
          this.hygList = response.data
        },
        err => {
          this.msg(err, 0)
        })
    },
    loadIncidentClass () {
      this.incidentTypes = {}
      return this.fetchDashboardApi('loadIncidentClass', config.API_URL + '/getIncidentClass/', undefined,
        response => {
          this.incidentTypes = handy.unique(response.data.map(rec => rec.incident_type)).sort()
          return this.loadIncidents()
        },
        err => {
          this.msg(err, true)
        })
    },
    loadIncidents () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: !this.aDay ? handy.formatDBDate(this.trendFrom) + ' 00:00:00' : this.fromDate + ' 00:00:00',
          to_dt: !this.aDay ? handy.formatDBDate(this.trendFrom) + ' 23:59:59' : this.fromDate + ' 23:59:59'
        }
      }
      this.incidentList = []
      return this.fetchDashboardApi('loadIncidents', config.API_URL + '/getIncidentListDailyRep/', qry,
        response => {
          if (response.data.length > 0) {
            this.incidentList = response.data
          } else {
            if (this.incidentTypes.length > 0) {
              this.incidentTypes.forEach(rec => {
                this.incidentList.push({
                  incident_type: rec,
                  incident_class: 'NIL'
                })
              })
            }
          }
        },
        err => {
          this.msg(err, 0)
        })
    },
    loadRemark () {
      var qry = {
        params: {
          from_dt: !this.aDay ? handy.formatDBDate(this.trendFrom) : this.fromDate,
          to_dt: !this.aDay ? handy.formatDBDate(this.trendFrom) : this.fromDate,
          comm_id: config.COMM_ID
        }
      }
      return this.fetchDashboardApi('loadRemark', config.API_URL + '/getRemarksBasedOnCommId/', qry,
        response => {
          if (response.data.length > 0) {
            this.lReport.remark_attendance = response.data[0].remark_attendance
            this.lReport.remark_water = response.data[0].remark_water
            this.lReport.remark_power = response.data[0].remark_power
          }
        },
        err => {
          this.msg(err, true)
        })
    },
    loadMoreRemark (curRemark) {
      var qry = {
        params: {
          from_dt: handy.formatDBDate(this.trendFrom),
          to_dt: handy.formatDBDate(this.trendTo),
          comm_id: config.COMM_ID
        }
      }
      this.lReport.AttRemark = {}
      this.lReport.PowerRemark = {}
      this.lReport.WaterRemark = {}
      this.axios.get(config.API_URL + '/getRemarksBasedOnCommId/', qry)
      .then(response => {
        this.lReport.AttRemark = response.data.filter(rec => rec.remark_attendance !== null)
        this.lReport.PowerRemark = response.data.filter(rec => rec.remark_power !== null)
        this.lReport.WaterRemark = response.data.filter(rec => rec.remark_water !== null)
        this.showRemark = true
        if (curRemark === 'Att') {
          this.lReport.remark = 'Att'
        } else if (curRemark === 'Power') {
          this.lReport.remark = 'Power'
        } else {
          this.lReport.remark = 'Water'
        }
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadSanityChecksMore () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.trendFrom),
          to_dt: handy.formatDBDate(this.trendTo)
        }
      }
      this.sanList = []
      this.lSan = {}
      this.axios.get(config.API_URL + '/getSanCheckByCommIdAndcDate/', qry)
      .then(response => {
        this.sanList = response.data
        this.lSan = handy.unique(this.sanList.map(rec => handy.formatDate(rec.c_date)))
        this.showSanityChecks = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadIncidentMore () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: this.trendFrom,
          to_dt: this.trendTo
        }
      }
      this.lIncident = []
      this.lInc = {}
      this.axios.get(config.API_URL + '/getIncidentListDailyRep/', qry)
      .then(response => {
        this.lIncident = response.data
        this.lInc = handy.unique(this.lIncident.map(rec => handy.formatDate(rec.created_on)))
        this.showIncident = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    scrollToSection () {
      let element = this.$refs[this.sectionList[this.curSec++]]
      element.scrollIntoView()
      if (this.curSec === this.sectionList.length) {
        this.curSec = 0
      }
    },
    enableAutoRef () {
      this.isAutoRef = !this.isAutoRef
      if (this.isAutoRef) {
        // set timer to refresh the data every min -- force-refresh so it actually bypasses
        // the cache each tick instead of just replaying whatever is already cached
        this.timer = setInterval(() => this.loadDashboardBasedOnPeriod(this.enableChip, true), 60000)
        // scroll to
        this.secTimer = setInterval(this.scrollToSection, 10000)
      } else {
        clearInterval(this.timer)
        clearInterval(this.secTimer)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Facdash.vue?5af57c28